import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Any: any;
  JSON: any;
  JSONB: any;
  Map: any;
  NullBool: any;
  NullInt64: any;
  NullString: string;
  NullTime: any;
  Numeric: any;
  Time: any;
  UUID: any;
  Upload: any;
};

export type GQLAddTranslationParams = {
  En: Scalars['String'];
  Key: Scalars['String'];
  Namespace: Scalars['String'];
  Nl?: InputMaybe<Scalars['NullString']>;
};

export type GQLAssignTaskParams = {
  assignedTo: Scalars['String'];
  taskID: Scalars['ID'];
};

export type GQLAvailableFormsRow = {
  __typename?: 'AvailableFormsRow';
  customForm?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['NullString']>;
  enabled?: Maybe<Scalars['Boolean']>;
  formID?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

export type GQLCategoryNode = {
  __typename?: 'CategoryNode';
  categoryID: Scalars['ID'];
  children?: Maybe<Array<GQLCategoryNode>>;
  items?: Maybe<Array<GQLContentItem>>;
  name?: Maybe<Scalars['String']>;
};

export type GQLContentForm = {
  __typename?: 'ContentForm';
  defaultData?: Maybe<Scalars['JSON']>;
  description?: Maybe<Scalars['NullString']>;
  formID: Scalars['ID'];
  formSchema?: Maybe<Scalars['JSON']>;
  formVersion: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  uiSchema?: Maybe<Scalars['JSON']>;
};

export type GQLContentFormResult = {
  formData: Scalars['JSON'];
  formID: Scalars['ID'];
  formResultID?: InputMaybe<Scalars['ID']>;
  formVersion: Scalars['ID'];
};

export type GQLContentItem = {
  __typename?: 'ContentItem';
  createdAt?: Maybe<Scalars['NullTime']>;
  createdBy?: Maybe<Scalars['NullString']>;
  deleted?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['NullString']>;
  downloadUrl?: Maybe<Scalars['String']>;
  itemID: Scalars['ID'];
  mimetype?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  roles: Array<Scalars['ID']>;
  sensitivityLevel?: Maybe<Scalars['ID']>;
};

export type GQLDictionary = {
  __typename?: 'Dictionary';
  en: Scalars['String'];
  id: Scalars['ID'];
  key: Scalars['String'];
  namespace: Scalars['String'];
  nl?: Maybe<Scalars['NullString']>;
};

export type GQLDisabledTenantFormPartsByFormIdRow = {
  __typename?: 'DisabledTenantFormPartsByFormIDRow';
  formID?: Maybe<Scalars['ID']>;
  formPartID?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type GQLDisabledTenantFormsRow = {
  __typename?: 'DisabledTenantFormsRow';
  customForm?: Maybe<Scalars['Boolean']>;
  formID?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

export type GQLEnabledTenantFormPartsByFormIdRow = {
  __typename?: 'EnabledTenantFormPartsByFormIDRow';
  formID?: Maybe<Scalars['ID']>;
  formPartID?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type GQLEnabledTenantFormsRow = {
  __typename?: 'EnabledTenantFormsRow';
  customForm?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['NullString']>;
  formID?: Maybe<Scalars['Int']>;
  isConfigurable?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
};

export type GQLFormResultByIdRow = {
  __typename?: 'FormResultByIDRow';
  createdAt?: Maybe<Scalars['Time']>;
  createdBy?: Maybe<GQLIamUser>;
  formData?: Maybe<Scalars['JSON']>;
  formID?: Maybe<Scalars['ID']>;
  formResultID?: Maybe<Scalars['ID']>;
  formSchema?: Maybe<Scalars['JSON']>;
  formVersion?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  submittedAt?: Maybe<Scalars['NullTime']>;
  uiSchema?: Maybe<Scalars['JSON']>;
};

export type GQLIamPermission = {
  __typename?: 'IamPermission';
  description?: Maybe<Scalars['NullString']>;
  permissionID?: Maybe<Scalars['ID']>;
  permissionName?: Maybe<Scalars['String']>;
};

export type GQLIamRole = {
  __typename?: 'IamRole';
  description?: Maybe<Scalars['NullString']>;
  roleID?: Maybe<Scalars['ID']>;
  roleName?: Maybe<Scalars['String']>;
};

export type GQLIamUser = {
  __typename?: 'IamUser';
  active?: Maybe<Scalars['Boolean']>;
  avatar?: Maybe<Scalars['NullString']>;
  emailAddress?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  infix?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  permissions?: Maybe<Array<Scalars['String']>>;
  preferences?: Maybe<Scalars['JSONB']>;
  roles?: Maybe<Array<GQLIamRole>>;
  tenantDetails?: Maybe<GQLTenantDetailsRow>;
  tenantID?: Maybe<Scalars['UUID']>;
  userID?: Maybe<Scalars['String']>;
};

export type GQLKpiIncidentsByCategoryRow = {
  __typename?: 'KpiIncidentsByCategoryRow';
  category?: Maybe<Scalars['String']>;
  count?: Maybe<Scalars['Int']>;
};

export type GQLMutation = {
  __typename?: 'Mutation';
  ActivateTenantFromRegistrationID: GQLSuccess;
  AddTranslation: GQLSuccess;
  AssignTask?: Maybe<GQLSuccess>;
  NewCategory?: Maybe<GQLSuccess>;
  NewContentItem?: Maybe<GQLSuccess>;
  NewTask?: Maybe<GQLSuccess>;
  NewTenantRegistration: GQLSuccess;
  NewUser: GQLIamUser;
  RemoveCategory?: Maybe<GQLSuccess>;
  RemoveContentItem?: Maybe<GQLSuccess>;
  RemoveDraftForm?: Maybe<GQLSuccess>;
  RequestResetPassword?: Maybe<GQLSuccess>;
  SetUserPreferences: GQLSuccess;
  SetUserStatus: GQLSuccess;
  StoreForm?: Maybe<GQLContentForm>;
  StoreFormResult: Scalars['ID'];
  SubmitFormResult?: Maybe<GQLSuccess>;
  TaskNewComment?: Maybe<GQLSuccess>;
  TenantRegistrationCreateAdmin: GQLSuccess;
  TenantRegistrationSetStatus: GQLSuccess;
  TenantSetStatus: GQLSuccess;
  UpdateCategoryName?: Maybe<GQLSuccess>;
  UpdateContentItemRoles?: Maybe<GQLSuccess>;
  UpdateCustomEnabledForms?: Maybe<GQLSuccess>;
  UpdateEnabledForms?: Maybe<GQLSuccess>;
  UpdateFormEnabled?: Maybe<GQLSuccess>;
  UpdateTask?: Maybe<GQLSuccess>;
  UpdateTaskStatus?: Maybe<GQLSuccess>;
  UpdateTenantFormPartsByFormID?: Maybe<GQLSuccess>;
  UpdateTenantOrganization: GQLSuccess;
  UpdateTenantRegistration: GQLSuccess;
  UpdateTranslation: GQLSuccess;
  UpdateUserByID: GQLSuccess;
  UpdateUserRoles: GQLSuccess;
};


export type GQLMutationActivateTenantFromRegistrationIdArgs = {
  registrationID: Scalars['ID'];
};


export type GQLMutationAddTranslationArgs = {
  input: GQLAddTranslationParams;
};


export type GQLMutationAssignTaskArgs = {
  input: GQLAssignTaskParams;
};


export type GQLMutationNewCategoryArgs = {
  categoryName: Scalars['String'];
};


export type GQLMutationNewContentItemArgs = {
  category: Scalars['ID'];
  item: GQLNewItemParams;
};


export type GQLMutationNewTaskArgs = {
  input: GQLNewTaskParams;
};


export type GQLMutationNewTenantRegistrationArgs = {
  input: GQLNewRegistrationParams;
};


export type GQLMutationNewUserArgs = {
  input: GQLNewUserParams;
};


export type GQLMutationRemoveCategoryArgs = {
  categoryID: Scalars['ID'];
};


export type GQLMutationRemoveContentItemArgs = {
  itemID: Scalars['ID'];
};


export type GQLMutationRemoveDraftFormArgs = {
  formResultID: Scalars['ID'];
};


export type GQLMutationRequestResetPasswordArgs = {
  userID: Scalars['String'];
};


export type GQLMutationSetUserPreferencesArgs = {
  preferences: Scalars['JSONB'];
};


export type GQLMutationSetUserStatusArgs = {
  active: Scalars['Boolean'];
  userID: Scalars['String'];
};


export type GQLMutationStoreFormArgs = {
  input: GQLStoreFormParams;
  newVersion?: InputMaybe<Scalars['Boolean']>;
};


export type GQLMutationStoreFormResultArgs = {
  input: GQLContentFormResult;
};


export type GQLMutationSubmitFormResultArgs = {
  formDataID: Scalars['ID'];
};


export type GQLMutationTaskNewCommentArgs = {
  input: GQLTaskNewCommentParams;
};


export type GQLMutationTenantRegistrationCreateAdminArgs = {
  registrationID: Scalars['ID'];
};


export type GQLMutationTenantRegistrationSetStatusArgs = {
  registrationID: Scalars['ID'];
  status: GQLRegistrationStatus;
};


export type GQLMutationTenantSetStatusArgs = {
  input: GQLTenantSetStatusParams;
};


export type GQLMutationUpdateCategoryNameArgs = {
  input: GQLUpdateCategoryNameParams;
};


export type GQLMutationUpdateContentItemRolesArgs = {
  input?: InputMaybe<GQLUpdateContentItemRoleParams>;
};


export type GQLMutationUpdateCustomEnabledFormsArgs = {
  input: Array<GQLUpdateCustomFormEnabledParams>;
};


export type GQLMutationUpdateEnabledFormsArgs = {
  formIDs: Array<Scalars['Int']>;
};


export type GQLMutationUpdateFormEnabledArgs = {
  customForm: Scalars['Boolean'];
  input: GQLUpdateFormEnabledParams;
};


export type GQLMutationUpdateTaskArgs = {
  input: GQLUpdateTaskParams;
};


export type GQLMutationUpdateTaskStatusArgs = {
  input: GQLUpdateTaskStatusParams;
};


export type GQLMutationUpdateTenantFormPartsByFormIdArgs = {
  formID: Scalars['ID'];
  formParts: Array<Scalars['String']>;
};


export type GQLMutationUpdateTenantOrganizationArgs = {
  organiztionInput: GQLUpdateOrganizationParams;
  tenantInput: GQLUpdateTenantParams;
};


export type GQLMutationUpdateTenantRegistrationArgs = {
  input: GQLUpdateRegistrationParams;
};


export type GQLMutationUpdateTranslationArgs = {
  input: GQLUpdateTranslationParams;
};


export type GQLMutationUpdateUserByIdArgs = {
  input: GQLUpdateUserByIdParams;
};


export type GQLMutationUpdateUserRolesArgs = {
  roles?: InputMaybe<Array<Scalars['ID']>>;
  userID: Scalars['String'];
};

export type GQLMyDraftFormsRow = {
  __typename?: 'MyDraftFormsRow';
  createdAt?: Maybe<Scalars['Time']>;
  description?: Maybe<Scalars['NullString']>;
  formData?: Maybe<Scalars['JSON']>;
  formID: Scalars['ID'];
  formResultID: Scalars['ID'];
  formSchema?: Maybe<Scalars['JSON']>;
  formVersion: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  uiSchema?: Maybe<Scalars['JSON']>;
};

export type GQLNewItemParams = {
  description?: InputMaybe<Scalars['NullString']>;
  downloadURL: Scalars['String'];
  mimeType: Scalars['String'];
  name: Scalars['String'];
  roles: Array<Scalars['ID']>;
};

export type GQLNewRegistrationParams = {
  adminEmailAddress: Scalars['String'];
  adminFirstName: Scalars['String'];
  adminInfix?: InputMaybe<Scalars['NullString']>;
  adminLastName: Scalars['String'];
  adminPhoneNumber?: InputMaybe<Scalars['NullString']>;
  city: Scalars['String'];
  emailAddressInvoice: Scalars['NullString'];
  houseNumber: Scalars['String'];
  isTrial: Scalars['Boolean'];
  name: Scalars['String'];
  postalCode: Scalars['String'];
  purchaseNumber?: InputMaybe<Scalars['NullString']>;
  reference?: InputMaybe<Scalars['NullString']>;
  street: Scalars['String'];
};

export type GQLNewTaskParams = {
  FormResultID?: InputMaybe<Scalars['ID']>;
  assignedTo?: InputMaybe<Scalars['String']>;
  dueDate: Scalars['Time'];
  priority: Scalars['String'];
  summary: Scalars['String'];
  type: Scalars['String'];
  url?: InputMaybe<Scalars['String']>;
};

export type GQLNewUserParams = {
  emailAddress: Scalars['String'];
  firstName: Scalars['String'];
  infix: Scalars['String'];
  lastName: Scalars['String'];
  roles?: InputMaybe<Array<Scalars['ID']>>;
};

export type GQLOpenTasksByFormResultIdRow = {
  __typename?: 'OpenTasksByFormResultIdRow';
  dueDate?: Maybe<Scalars['Time']>;
  openTasks?: Maybe<Scalars['Int']>;
};

export type GQLQuery = {
  __typename?: 'Query';
  AllUserTenants?: Maybe<Array<GQLTenantAllUserTenant>>;
  AvailableForms?: Maybe<Array<GQLAvailableFormsRow>>;
  CategoryStructure?: Maybe<Array<GQLCategoryNode>>;
  ContentItemsByCategoryID?: Maybe<Array<GQLContentItem>>;
  Dictionary: Scalars['JSON'];
  DisabledTenantFormPartsByFormID?: Maybe<Array<GQLDisabledTenantFormPartsByFormIdRow>>;
  DisabledTenantForms?: Maybe<Array<GQLDisabledTenantFormsRow>>;
  EnabledFeatures?: Maybe<Array<Scalars['String']>>;
  EnabledForms?: Maybe<Array<GQLContentForm>>;
  EnabledTenantFormPartsByFormID?: Maybe<Array<GQLEnabledTenantFormPartsByFormIdRow>>;
  EnabledTenantForms?: Maybe<Array<GQLEnabledTenantFormsRow>>;
  FormByID: GQLContentForm;
  FormDesignerByID: GQLContentForm;
  FormResultByID?: Maybe<GQLFormResultByIdRow>;
  IsPermitted?: Maybe<Scalars['Boolean']>;
  KPIDraftForms: Scalars['Int'];
  KPIIncidentsByCategory?: Maybe<Array<GQLKpiIncidentsByCategoryRow>>;
  KPISubmittedForms12Months: Scalars['Int'];
  KPISubmittedWPI12Months: Scalars['Int'];
  MyDraftForms?: Maybe<Array<GQLMyDraftFormsRow>>;
  OpenTenantRegistrations?: Maybe<Array<GQLTenantRegistration>>;
  Roles?: Maybe<Array<GQLIamRole>>;
  SubmittedForms?: Maybe<Array<GQLSubmittedFormsRow>>;
  TaskByTaskID: GQLTask;
  TaskCommentsByTaskID: Array<GQLTaskComment>;
  TaskOverview: Array<GQLTask>;
  TaskOverviewByFormResultID: Array<GQLTask>;
  TasksByMultipleFormIDs: Array<GQLTask>;
  TenantCompanyDetails?: Maybe<GQLTenantDetailsRow>;
  TenantOrganizationDetails?: Maybe<Array<GQLTenantOrganizationDetailsRow>>;
  TenantRegistrationByID: GQLTenantRegistration;
  Translations?: Maybe<Array<GQLDictionary>>;
  UserAccountByUserID?: Maybe<GQLIamUser>;
  UserAccounts?: Maybe<Array<GQLIamUser>>;
  currentUser?: Maybe<GQLIamUser>;
};


export type GQLQueryContentItemsByCategoryIdArgs = {
  categoryID: Scalars['ID'];
};


export type GQLQueryDisabledTenantFormPartsByFormIdArgs = {
  formID: Scalars['ID'];
};


export type GQLQueryEnabledTenantFormPartsByFormIdArgs = {
  formID: Scalars['ID'];
};


export type GQLQueryFormByIdArgs = {
  formID: Scalars['ID'];
};


export type GQLQueryFormDesignerByIdArgs = {
  formID: Scalars['ID'];
};


export type GQLQueryFormResultByIdArgs = {
  formResultID: Scalars['ID'];
};


export type GQLQueryIsPermittedArgs = {
  permission?: InputMaybe<Scalars['String']>;
};


export type GQLQueryTaskByTaskIdArgs = {
  taskID: Scalars['ID'];
};


export type GQLQueryTaskCommentsByTaskIdArgs = {
  taskID: Scalars['ID'];
};


export type GQLQueryTaskOverviewArgs = {
  filter: GQLTaskWithfilterOptionsParams;
};


export type GQLQueryTaskOverviewByFormResultIdArgs = {
  formResultID: Scalars['ID'];
};


export type GQLQueryTasksByMultipleFormIDsArgs = {
  formIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type GQLQueryTenantRegistrationByIdArgs = {
  registrationID: Scalars['ID'];
};


export type GQLQueryUserAccountByUserIdArgs = {
  userID: Scalars['String'];
};


export type GQLQueryUserAccountsArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
};

export enum GQLRegistrationStatus {
  AdminDone = 'ADMIN_DONE',
  Completed = 'COMPLETED',
  Invoiced = 'INVOICED',
  Trial = 'TRIAL'
}

export type GQLStoreFormParams = {
  description?: InputMaybe<Scalars['NullString']>;
  formID: Scalars['ID'];
  formSchema: Scalars['JSON'];
  formVersion?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  uiSchema: Scalars['JSON'];
};

export type GQLSubmittedFormsRow = {
  __typename?: 'SubmittedFormsRow';
  createdAt?: Maybe<Scalars['Time']>;
  createdBy?: Maybe<GQLIamUser>;
  formID?: Maybe<Scalars['ID']>;
  formResultID?: Maybe<Scalars['ID']>;
  formVersion?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  submittedAt?: Maybe<Scalars['NullTime']>;
};

export type GQLSuccess = {
  __typename?: 'Success';
  success?: Maybe<Scalars['Boolean']>;
};

export type GQLTask = {
  __typename?: 'Task';
  FormResultID?: Maybe<Scalars['ID']>;
  assignedTo?: Maybe<Scalars['String']>;
  assignedToName?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Time']>;
  createdBy?: Maybe<Scalars['String']>;
  dueDate?: Maybe<Scalars['Time']>;
  priority?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  summary?: Maybe<Scalars['String']>;
  taskID?: Maybe<Scalars['ID']>;
  type?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type GQLTaskComment = {
  __typename?: 'TaskComment';
  commentID?: Maybe<Scalars['ID']>;
  createdAt?: Maybe<Scalars['Time']>;
  createdBy?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  taskID?: Maybe<Scalars['ID']>;
};

export type GQLTaskNewCommentParams = {
  description?: InputMaybe<Scalars['String']>;
  taskID: Scalars['ID'];
};

export type GQLTaskWithfilterOptionsParams = {
  assignedTo?: InputMaybe<Array<Scalars['String']>>;
  showAll?: InputMaybe<Scalars['Boolean']>;
  statusFilter: Array<Scalars['String']>;
};

export type GQLTenantAllUserTenant = {
  __typename?: 'TenantAllUserTenant';
  TenantID?: Maybe<Scalars['UUID']>;
  name?: Maybe<Scalars['String']>;
};

export type GQLTenantDetailsRow = {
  __typename?: 'TenantDetailsRow';
  config?: Maybe<Scalars['JSON']>;
  logo?: Maybe<Scalars['NullString']>;
  name?: Maybe<Scalars['String']>;
};

export type GQLTenantOrganizationDetailsRow = {
  __typename?: 'TenantOrganizationDetailsRow';
  city?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['NullTime']>;
  emailAddressInvoice?: Maybe<Scalars['NullString']>;
  enabled?: Maybe<Scalars['Boolean']>;
  houseNumber?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['NullString']>;
  name?: Maybe<Scalars['String']>;
  organizationID: Scalars['ID'];
  postalCode?: Maybe<Scalars['String']>;
  purchaseNumber?: Maybe<Scalars['NullString']>;
  status?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  tenantID?: Maybe<Scalars['UUID']>;
  trialStartDate?: Maybe<Scalars['NullTime']>;
};

export type GQLTenantRegistration = {
  __typename?: 'TenantRegistration';
  adminEmailAddress?: Maybe<Scalars['String']>;
  adminFirstName?: Maybe<Scalars['String']>;
  adminInfix?: Maybe<Scalars['NullString']>;
  adminLastName?: Maybe<Scalars['String']>;
  adminPhoneNumber?: Maybe<Scalars['NullString']>;
  city?: Maybe<Scalars['String']>;
  emailAddressInvoice?: Maybe<Scalars['NullString']>;
  houseNumber?: Maybe<Scalars['String']>;
  isTrial?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  purchaseNumber?: Maybe<Scalars['NullString']>;
  registrationID: Scalars['ID'];
  status?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  tenantID?: Maybe<Scalars['UUID']>;
};

export type GQLTenantSetStatusParams = {
  status: Scalars['String'];
  tenantID: Scalars['UUID'];
};

export enum GQLTenantStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Trial = 'TRIAL',
  TrialExpired = 'TRIAL_EXPIRED'
}

export type GQLUpdateCategoryNameParams = {
  categoryID: Scalars['ID'];
  name: Scalars['String'];
};

export type GQLUpdateContentItemRoleParams = {
  itemID: Scalars['ID'];
  roles: Array<Scalars['ID']>;
};

export type GQLUpdateCustomFormEnabledParams = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  formID: Scalars['ID'];
  formVersion?: InputMaybe<Scalars['ID']>;
};

export type GQLUpdateFormEnabledParams = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  formID: Scalars['ID'];
  formVersion?: InputMaybe<Scalars['ID']>;
};

export type GQLUpdateOrganizationParams = {
  city?: InputMaybe<Scalars['String']>;
  emailAddressInvoice?: InputMaybe<Scalars['NullString']>;
  houseNumber?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  purchaseNumber?: InputMaybe<Scalars['NullString']>;
  street?: InputMaybe<Scalars['String']>;
};

export type GQLUpdateRegistrationParams = {
  adminEmailAddress: Scalars['String'];
  adminFirstName: Scalars['String'];
  adminInfix?: InputMaybe<Scalars['NullString']>;
  adminLastName: Scalars['String'];
  adminPhoneNumber?: InputMaybe<Scalars['NullString']>;
  city: Scalars['String'];
  emailAddressInvoice: Scalars['NullString'];
  houseNumber: Scalars['String'];
  isTrial: Scalars['Boolean'];
  name: Scalars['String'];
  postalCode: Scalars['String'];
  purchaseNumber?: InputMaybe<Scalars['NullString']>;
  registrationID: Scalars['ID'];
  street: Scalars['String'];
};

export type GQLUpdateTaskParams = {
  dueDate: Scalars['Time'];
  priority: Scalars['String'];
  summary: Scalars['String'];
  taskID: Scalars['ID'];
  type: Scalars['String'];
};

export type GQLUpdateTaskStatusParams = {
  status: Scalars['String'];
  taskID: Scalars['ID'];
};

export type GQLUpdateTenantParams = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  tenantID: Scalars['UUID'];
  trialStartDate?: InputMaybe<Scalars['NullTime']>;
};

export type GQLUpdateTranslationParams = {
  En: Scalars['String'];
  Key: Scalars['String'];
  Namespace: Scalars['String'];
  NewKey: Scalars['String'];
  NewNamespace: Scalars['String'];
  Nl?: InputMaybe<Scalars['NullString']>;
};

export type GQLUpdateUserByIdParams = {
  firstName: Scalars['String'];
  infix: Scalars['String'];
  lastName: Scalars['String'];
  roles?: InputMaybe<Array<Scalars['ID']>>;
  userID: Scalars['String'];
};

export type GQLVoid = {
  __typename?: 'Void';
  void?: Maybe<Scalars['String']>;
};

export type GQLActivateTenantFromRegistrationIdMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GQLActivateTenantFromRegistrationIdMutation = { __typename?: 'Mutation', ActivateTenantFromRegistrationID: { __typename?: 'Success', success?: boolean | null } };

export type GQLAddTranslationMutationVariables = Exact<{
  input: GQLAddTranslationParams;
}>;


export type GQLAddTranslationMutation = { __typename?: 'Mutation', AddTranslation: { __typename?: 'Success', success?: boolean | null } };

export type GQLAssignTaskMutationVariables = Exact<{
  input: GQLAssignTaskParams;
}>;


export type GQLAssignTaskMutation = { __typename?: 'Mutation', AssignTask?: { __typename?: 'Success', success?: boolean | null } | null };

export type GQLNewCategoryMutationVariables = Exact<{
  input: Scalars['String'];
}>;


export type GQLNewCategoryMutation = { __typename?: 'Mutation', NewCategory?: { __typename?: 'Success', success?: boolean | null } | null };

export type GQLNewContentItemMutationVariables = Exact<{
  input: GQLNewItemParams;
  catID: Scalars['ID'];
}>;


export type GQLNewContentItemMutation = { __typename?: 'Mutation', NewContentItem?: { __typename?: 'Success', success?: boolean | null } | null };

export type GQLNewTaskMutationVariables = Exact<{
  input: GQLNewTaskParams;
}>;


export type GQLNewTaskMutation = { __typename?: 'Mutation', NewTask?: { __typename?: 'Success', success?: boolean | null } | null };

export type GQLNewTenantRegistrationMutationVariables = Exact<{
  input: GQLNewRegistrationParams;
}>;


export type GQLNewTenantRegistrationMutation = { __typename?: 'Mutation', NewTenantRegistration: { __typename?: 'Success', success?: boolean | null } };

export type GQLNewUserMutationVariables = Exact<{
  input: GQLNewUserParams;
}>;


export type GQLNewUserMutation = { __typename?: 'Mutation', NewUser: { __typename?: 'IamUser', userID?: string | null } };

export type GQLRemoveCategoryMutationVariables = Exact<{
  categoryID: Scalars['ID'];
}>;


export type GQLRemoveCategoryMutation = { __typename?: 'Mutation', RemoveCategory?: { __typename?: 'Success', success?: boolean | null } | null };

export type GQLRemoveContentItemMutationVariables = Exact<{
  itemID: Scalars['ID'];
}>;


export type GQLRemoveContentItemMutation = { __typename?: 'Mutation', RemoveContentItem?: { __typename?: 'Success', success?: boolean | null } | null };

export type GQLRemoveDraftFormMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GQLRemoveDraftFormMutation = { __typename?: 'Mutation', RemoveDraftForm?: { __typename?: 'Success', success?: boolean | null } | null };

export type GQLRequestResetPasswordMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type GQLRequestResetPasswordMutation = { __typename?: 'Mutation', RequestResetPassword?: { __typename?: 'Success', success?: boolean | null } | null };

export type GQLSetUserPreferencesMutationVariables = Exact<{
  input: Scalars['JSONB'];
}>;


export type GQLSetUserPreferencesMutation = { __typename?: 'Mutation', SetUserPreferences: { __typename?: 'Success', success?: boolean | null } };

export type GQLSetUserStatusMutationVariables = Exact<{
  id: Scalars['String'];
  active: Scalars['Boolean'];
}>;


export type GQLSetUserStatusMutation = { __typename?: 'Mutation', SetUserStatus: { __typename?: 'Success', success?: boolean | null } };

export type GQLStoreFormMutationVariables = Exact<{
  input: GQLStoreFormParams;
}>;


export type GQLStoreFormMutation = { __typename?: 'Mutation', StoreForm?: { __typename?: 'ContentForm', formID: string, name?: string | null, description?: string | null, formSchema?: any | null, uiSchema?: any | null, defaultData?: any | null } | null };

export type GQLStoreFormResultMutationVariables = Exact<{
  input: GQLContentFormResult;
}>;


export type GQLStoreFormResultMutation = { __typename?: 'Mutation', StoreFormResult: string };

export type GQLSubmitFormResultMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GQLSubmitFormResultMutation = { __typename?: 'Mutation', SubmitFormResult?: { __typename?: 'Success', success?: boolean | null } | null };

export type GQLTaskNewCommentMutationVariables = Exact<{
  input: GQLTaskNewCommentParams;
}>;


export type GQLTaskNewCommentMutation = { __typename?: 'Mutation', TaskNewComment?: { __typename?: 'Success', success?: boolean | null } | null };

export type GQLTenantRegistrationCreateAdminMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GQLTenantRegistrationCreateAdminMutation = { __typename?: 'Mutation', TenantRegistrationCreateAdmin: { __typename?: 'Success', success?: boolean | null } };

export type GQLTenantRegistrationSetStatusMutationVariables = Exact<{
  registrationID: Scalars['ID'];
  status: GQLRegistrationStatus;
}>;


export type GQLTenantRegistrationSetStatusMutation = { __typename?: 'Mutation', TenantRegistrationSetStatus: { __typename?: 'Success', success?: boolean | null } };

export type GQLTenantSetStatusMutationVariables = Exact<{
  input: GQLTenantSetStatusParams;
}>;


export type GQLTenantSetStatusMutation = { __typename?: 'Mutation', TenantSetStatus: { __typename?: 'Success', success?: boolean | null } };

export type GQLUpdateCategoryNameMutationVariables = Exact<{
  input: GQLUpdateCategoryNameParams;
}>;


export type GQLUpdateCategoryNameMutation = { __typename?: 'Mutation', UpdateCategoryName?: { __typename?: 'Success', success?: boolean | null } | null };

export type GQLUpdateContentItemRolesMutationVariables = Exact<{
  input?: InputMaybe<GQLUpdateContentItemRoleParams>;
}>;


export type GQLUpdateContentItemRolesMutation = { __typename?: 'Mutation', UpdateContentItemRoles?: { __typename?: 'Success', success?: boolean | null } | null };

export type GQLUpdateCustomEnabledFormsMutationVariables = Exact<{
  input: Array<GQLUpdateCustomFormEnabledParams> | GQLUpdateCustomFormEnabledParams;
}>;


export type GQLUpdateCustomEnabledFormsMutation = { __typename?: 'Mutation', UpdateCustomEnabledForms?: { __typename?: 'Success', success?: boolean | null } | null };

export type GQLUpdateEnabledFormsMutationVariables = Exact<{
  ids: Array<Scalars['Int']> | Scalars['Int'];
}>;


export type GQLUpdateEnabledFormsMutation = { __typename?: 'Mutation', UpdateEnabledForms?: { __typename?: 'Success', success?: boolean | null } | null };

export type GQLUpdateFormEnabledMutationVariables = Exact<{
  input: GQLUpdateFormEnabledParams;
  customForm: Scalars['Boolean'];
}>;


export type GQLUpdateFormEnabledMutation = { __typename?: 'Mutation', UpdateFormEnabled?: { __typename?: 'Success', success?: boolean | null } | null };

export type GQLUpdateTaskMutationVariables = Exact<{
  input: GQLUpdateTaskParams;
}>;


export type GQLUpdateTaskMutation = { __typename?: 'Mutation', UpdateTask?: { __typename?: 'Success', success?: boolean | null } | null };

export type GQLUpdateTaskStatusMutationVariables = Exact<{
  input: GQLUpdateTaskStatusParams;
}>;


export type GQLUpdateTaskStatusMutation = { __typename?: 'Mutation', UpdateTaskStatus?: { __typename?: 'Success', success?: boolean | null } | null };

export type GQLUpdateTenantFormPartsByFormIdMutationVariables = Exact<{
  formID: Scalars['ID'];
  formParts: Array<Scalars['String']> | Scalars['String'];
}>;


export type GQLUpdateTenantFormPartsByFormIdMutation = { __typename?: 'Mutation', UpdateTenantFormPartsByFormID?: { __typename?: 'Success', success?: boolean | null } | null };

export type GQLUpdateTenantOrganizationMutationVariables = Exact<{
  tenantInput: GQLUpdateTenantParams;
  organizationInput: GQLUpdateOrganizationParams;
}>;


export type GQLUpdateTenantOrganizationMutation = { __typename?: 'Mutation', UpdateTenantOrganization: { __typename?: 'Success', success?: boolean | null } };

export type GQLUpdateTenantRegistrationMutationVariables = Exact<{
  input: GQLUpdateRegistrationParams;
}>;


export type GQLUpdateTenantRegistrationMutation = { __typename?: 'Mutation', UpdateTenantRegistration: { __typename?: 'Success', success?: boolean | null } };

export type GQLUpdateTranslationMutationVariables = Exact<{
  input: GQLUpdateTranslationParams;
}>;


export type GQLUpdateTranslationMutation = { __typename?: 'Mutation', UpdateTranslation: { __typename?: 'Success', success?: boolean | null } };

export type GQLUpdateUserByIdMutationVariables = Exact<{
  input: GQLUpdateUserByIdParams;
}>;


export type GQLUpdateUserByIdMutation = { __typename?: 'Mutation', UpdateUserByID: { __typename?: 'Success', success?: boolean | null } };

export type GQLCurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GQLCurrentUserQuery = { __typename?: 'Query', currentUser?: { __typename?: 'IamUser', emailAddress?: string | null, userID?: string | null, active?: boolean | null, preferences?: any | null, avatar?: string | null, permissions?: Array<string> | null, firstName?: string | null, infix?: string | null, lastName?: string | null, tenantID?: any | null, roles?: Array<{ __typename?: 'IamRole', roleID?: string | null, roleName?: string | null, description?: string | null }> | null, tenantDetails?: { __typename?: 'TenantDetailsRow', name?: string | null, logo?: string | null, config?: any | null } | null } | null };

export type GQLGetEnabledFormsQueryVariables = Exact<{ [key: string]: never; }>;


export type GQLGetEnabledFormsQuery = { __typename?: 'Query', EnabledForms?: Array<{ __typename?: 'ContentForm', formID: string, formVersion: string, name?: string | null, description?: string | null, defaultData?: any | null }> | null };

export type GQLFormByIdQueryVariables = Exact<{
  formID: Scalars['ID'];
}>;


export type GQLFormByIdQuery = { __typename?: 'Query', FormByID: { __typename?: 'ContentForm', formID: string, formVersion: string, name?: string | null, description?: string | null, formSchema?: any | null, uiSchema?: any | null, defaultData?: any | null } };

export type GQLFormDesignerByIdQueryVariables = Exact<{
  formID: Scalars['ID'];
}>;


export type GQLFormDesignerByIdQuery = { __typename?: 'Query', FormDesignerByID: { __typename?: 'ContentForm', formID: string, formVersion: string, name?: string | null, description?: string | null, formSchema?: any | null, uiSchema?: any | null, defaultData?: any | null } };

export type GQLGetAllUserTenantsQueryVariables = Exact<{ [key: string]: never; }>;


export type GQLGetAllUserTenantsQuery = { __typename?: 'Query', AllUserTenants?: Array<{ __typename?: 'TenantAllUserTenant', name?: string | null, TenantID?: any | null }> | null };

export type GQLGetAvailableFormsQueryVariables = Exact<{ [key: string]: never; }>;


export type GQLGetAvailableFormsQuery = { __typename?: 'Query', AvailableForms?: Array<{ __typename?: 'AvailableFormsRow', name?: string | null, formID?: number | null, description?: string | null, enabled?: boolean | null, customForm?: boolean | null }> | null };

export type GQLGetCategoryStructureQueryVariables = Exact<{ [key: string]: never; }>;


export type GQLGetCategoryStructureQuery = { __typename?: 'Query', CategoryStructure?: Array<{ __typename?: 'CategoryNode', categoryID: string, name?: string | null, children?: Array<{ __typename?: 'CategoryNode', categoryID: string, name?: string | null }> | null, items?: Array<{ __typename?: 'ContentItem', itemID: string, name?: string | null, description?: string | null, createdAt?: any | null, createdBy?: string | null, sensitivityLevel?: string | null, deleted?: boolean | null, mimetype?: string | null, downloadUrl?: string | null, roles: Array<string> }> | null }> | null };

export type GQLGetContentItemsByCategoryIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GQLGetContentItemsByCategoryIdQuery = { __typename?: 'Query', ContentItemsByCategoryID?: Array<{ __typename?: 'ContentItem', itemID: string, name?: string | null, description?: string | null, createdAt?: any | null, createdBy?: string | null, sensitivityLevel?: string | null, deleted?: boolean | null, roles: Array<string>, mimetype?: string | null }> | null };

export type GQLGetDisabledTenantFormPartsByFormIdQueryVariables = Exact<{
  formID: Scalars['ID'];
}>;


export type GQLGetDisabledTenantFormPartsByFormIdQuery = { __typename?: 'Query', DisabledTenantFormPartsByFormID?: Array<{ __typename?: 'DisabledTenantFormPartsByFormIDRow', name?: string | null, formPartID?: string | null, formID?: string | null }> | null };

export type GQLGetDisabledTenantFormsQueryVariables = Exact<{ [key: string]: never; }>;


export type GQLGetDisabledTenantFormsQuery = { __typename?: 'Query', DisabledTenantForms?: Array<{ __typename?: 'DisabledTenantFormsRow', name?: string | null, formID?: number | null, customForm?: boolean | null }> | null };

export type GQLGetEnabledTenantFormPartsByFormIdQueryVariables = Exact<{
  formID: Scalars['ID'];
}>;


export type GQLGetEnabledTenantFormPartsByFormIdQuery = { __typename?: 'Query', EnabledTenantFormPartsByFormID?: Array<{ __typename?: 'EnabledTenantFormPartsByFormIDRow', name?: string | null, formPartID?: string | null, formID?: string | null }> | null };

export type GQLGetEnabledTenantFormsQueryVariables = Exact<{ [key: string]: never; }>;


export type GQLGetEnabledTenantFormsQuery = { __typename?: 'Query', EnabledTenantForms?: Array<{ __typename?: 'EnabledTenantFormsRow', name?: string | null, description?: string | null, formID?: number | null, isConfigurable?: boolean | null, customForm?: boolean | null }> | null };

export type GQLGetFormResultByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GQLGetFormResultByIdQuery = { __typename?: 'Query', FormResultByID?: { __typename?: 'FormResultByIDRow', formResultID?: string | null, formID?: string | null, formVersion?: string | null, name?: string | null, formSchema?: any | null, uiSchema?: any | null, formData?: any | null, createdAt?: any | null, submittedAt?: any | null, createdBy?: { __typename?: 'IamUser', firstName?: string | null, infix?: string | null, lastName?: string | null, tenantID?: any | null } | null } | null };

export type GQLGetKpiDraftFormsQueryVariables = Exact<{ [key: string]: never; }>;


export type GQLGetKpiDraftFormsQuery = { __typename?: 'Query', KPIDraftForms: number };

export type GQLGetKpiIncidentsByCategoryQueryVariables = Exact<{ [key: string]: never; }>;


export type GQLGetKpiIncidentsByCategoryQuery = { __typename?: 'Query', KPIIncidentsByCategory?: Array<{ __typename?: 'KpiIncidentsByCategoryRow', category?: string | null, count?: number | null }> | null };

export type GQLGetKpiSubmittedForms12MonthsQueryVariables = Exact<{ [key: string]: never; }>;


export type GQLGetKpiSubmittedForms12MonthsQuery = { __typename?: 'Query', KPISubmittedForms12Months: number };

export type GQLGetKpiSubmittedWpi12MonthsQueryVariables = Exact<{ [key: string]: never; }>;


export type GQLGetKpiSubmittedWpi12MonthsQuery = { __typename?: 'Query', KPISubmittedWPI12Months: number };

export type GQLGetOpenTenantRegistrationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GQLGetOpenTenantRegistrationsQuery = { __typename?: 'Query', OpenTenantRegistrations?: Array<{ __typename?: 'TenantRegistration', registrationID: string, tenantID?: any | null, name?: string | null, street?: string | null, houseNumber?: string | null, postalCode?: string | null, city?: string | null, emailAddressInvoice?: string | null, adminEmailAddress?: string | null, adminFirstName?: string | null, adminInfix?: string | null, adminLastName?: string | null, adminPhoneNumber?: string | null, purchaseNumber?: string | null, status?: string | null, isTrial?: boolean | null }> | null };

export type GQLGetSubmittedFormsQueryVariables = Exact<{ [key: string]: never; }>;


export type GQLGetSubmittedFormsQuery = { __typename?: 'Query', SubmittedForms?: Array<{ __typename?: 'SubmittedFormsRow', formResultID?: string | null, formID?: string | null, formVersion?: string | null, name?: string | null, createdAt?: any | null, submittedAt?: any | null, createdBy?: { __typename?: 'IamUser', firstName?: string | null, infix?: string | null, lastName?: string | null, tenantID?: any | null } | null }> | null };

export type GQLGetTaskByTaskIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GQLGetTaskByTaskIdQuery = { __typename?: 'Query', TaskByTaskID: { __typename?: 'Task', taskID?: string | null, summary?: string | null, status?: string | null, type?: string | null, priority?: string | null, createdBy?: string | null, createdAt?: any | null, assignedTo?: string | null, assignedToName?: string | null, dueDate?: any | null, url?: string | null } };

export type GQLGetTaskCommentsByTaskIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GQLGetTaskCommentsByTaskIdQuery = { __typename?: 'Query', TaskCommentsByTaskID: Array<{ __typename?: 'TaskComment', commentID?: string | null, taskID?: string | null, description?: string | null, createdBy?: string | null, createdAt?: any | null }> };

export type GQLGetTaskOverviewQueryVariables = Exact<{
  filter: GQLTaskWithfilterOptionsParams;
}>;


export type GQLGetTaskOverviewQuery = { __typename?: 'Query', TaskOverview: Array<{ __typename?: 'Task', FormResultID?: string | null, taskID?: string | null, summary?: string | null, status?: string | null, type?: string | null, priority?: string | null, createdBy?: string | null, createdAt?: any | null, assignedTo?: string | null, assignedToName?: string | null, dueDate?: any | null, url?: string | null }> };

export type GQLTaskOverviewByFormResultIdQueryVariables = Exact<{
  formResultID: Scalars['ID'];
}>;


export type GQLTaskOverviewByFormResultIdQuery = { __typename?: 'Query', TaskOverviewByFormResultID: Array<{ __typename?: 'Task', taskID?: string | null, summary?: string | null, status?: string | null, type?: string | null, priority?: string | null, createdBy?: string | null, createdAt?: any | null, assignedTo?: string | null, assignedToName?: string | null, dueDate?: any | null, FormResultID?: string | null, url?: string | null }> };

export type GQLGetTenantOrganizationDetailsQueryVariables = Exact<{ [key: string]: never; }>;


export type GQLGetTenantOrganizationDetailsQuery = { __typename?: 'Query', TenantOrganizationDetails?: Array<{ __typename?: 'TenantOrganizationDetailsRow', organizationID: string, tenantID?: any | null, name?: string | null, logo?: string | null, street?: string | null, houseNumber?: string | null, postalCode?: string | null, city?: string | null, emailAddressInvoice?: string | null, purchaseNumber?: string | null, enabled?: boolean | null, createdAt?: any | null, trialStartDate?: any | null, status?: string | null }> | null };

export type GQLGetTranslationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GQLGetTranslationsQuery = { __typename?: 'Query', Translations?: Array<{ __typename?: 'Dictionary', id: string, namespace: string, key: string, en: string, nl?: string | null }> | null };

export type GQLGetUserAccountsQueryVariables = Exact<{
  active?: InputMaybe<Scalars['Boolean']>;
}>;


export type GQLGetUserAccountsQuery = { __typename?: 'Query', UserAccounts?: Array<{ __typename?: 'IamUser', emailAddress?: string | null, userID?: string | null, active?: boolean | null, preferences?: any | null, permissions?: Array<string> | null, firstName?: string | null, infix?: string | null, lastName?: string | null, tenantID?: any | null, fullName?: string | null, roles?: Array<{ __typename?: 'IamRole', roleID?: string | null, roleName?: string | null, description?: string | null }> | null }> | null };

export type GQLGetUserListQueryVariables = Exact<{
  active?: InputMaybe<Scalars['Boolean']>;
}>;


export type GQLGetUserListQuery = { __typename?: 'Query', UserAccounts?: Array<{ __typename?: 'IamUser', id?: string | null, name?: string | null }> | null };

export type GQLGetMyDraftFormsQueryVariables = Exact<{ [key: string]: never; }>;


export type GQLGetMyDraftFormsQuery = { __typename?: 'Query', MyDraftForms?: Array<{ __typename?: 'MyDraftFormsRow', formResultID: string, formID: string, formVersion: string, name?: string | null, description?: string | null, formSchema?: any | null, uiSchema?: any | null, formData?: any | null, createdAt?: any | null }> | null };

export type GQLGetUserRolesQueryVariables = Exact<{ [key: string]: never; }>;


export type GQLGetUserRolesQuery = { __typename?: 'Query', Roles?: Array<{ __typename?: 'IamRole', roleID?: string | null, roleName?: string | null }> | null };


export const ActivateTenantFromRegistrationIdDocument = gql`
    mutation ActivateTenantFromRegistrationID($id: ID!) {
  ActivateTenantFromRegistrationID(registrationID: $id) {
    success
  }
}
    `;
export type GQLActivateTenantFromRegistrationIdMutationFn = Apollo.MutationFunction<GQLActivateTenantFromRegistrationIdMutation, GQLActivateTenantFromRegistrationIdMutationVariables>;

/**
 * __useActivateTenantFromRegistrationIdMutation__
 *
 * To run a mutation, you first call `useActivateTenantFromRegistrationIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateTenantFromRegistrationIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateTenantFromRegistrationIdMutation, { data, loading, error }] = useActivateTenantFromRegistrationIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useActivateTenantFromRegistrationIdMutation(baseOptions?: Apollo.MutationHookOptions<GQLActivateTenantFromRegistrationIdMutation, GQLActivateTenantFromRegistrationIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GQLActivateTenantFromRegistrationIdMutation, GQLActivateTenantFromRegistrationIdMutationVariables>(ActivateTenantFromRegistrationIdDocument, options);
      }
export type ActivateTenantFromRegistrationIdMutationHookResult = ReturnType<typeof useActivateTenantFromRegistrationIdMutation>;
export type ActivateTenantFromRegistrationIdMutationResult = Apollo.MutationResult<GQLActivateTenantFromRegistrationIdMutation>;
export type ActivateTenantFromRegistrationIdMutationOptions = Apollo.BaseMutationOptions<GQLActivateTenantFromRegistrationIdMutation, GQLActivateTenantFromRegistrationIdMutationVariables>;
export const AddTranslationDocument = gql`
    mutation addTranslation($input: AddTranslationParams!) {
  AddTranslation(input: $input) {
    success
  }
}
    `;
export type GQLAddTranslationMutationFn = Apollo.MutationFunction<GQLAddTranslationMutation, GQLAddTranslationMutationVariables>;

/**
 * __useAddTranslationMutation__
 *
 * To run a mutation, you first call `useAddTranslationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTranslationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTranslationMutation, { data, loading, error }] = useAddTranslationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddTranslationMutation(baseOptions?: Apollo.MutationHookOptions<GQLAddTranslationMutation, GQLAddTranslationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GQLAddTranslationMutation, GQLAddTranslationMutationVariables>(AddTranslationDocument, options);
      }
export type AddTranslationMutationHookResult = ReturnType<typeof useAddTranslationMutation>;
export type AddTranslationMutationResult = Apollo.MutationResult<GQLAddTranslationMutation>;
export type AddTranslationMutationOptions = Apollo.BaseMutationOptions<GQLAddTranslationMutation, GQLAddTranslationMutationVariables>;
export const AssignTaskDocument = gql`
    mutation AssignTask($input: AssignTaskParams!) {
  AssignTask(input: $input) {
    success
  }
}
    `;
export type GQLAssignTaskMutationFn = Apollo.MutationFunction<GQLAssignTaskMutation, GQLAssignTaskMutationVariables>;

/**
 * __useAssignTaskMutation__
 *
 * To run a mutation, you first call `useAssignTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignTaskMutation, { data, loading, error }] = useAssignTaskMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAssignTaskMutation(baseOptions?: Apollo.MutationHookOptions<GQLAssignTaskMutation, GQLAssignTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GQLAssignTaskMutation, GQLAssignTaskMutationVariables>(AssignTaskDocument, options);
      }
export type AssignTaskMutationHookResult = ReturnType<typeof useAssignTaskMutation>;
export type AssignTaskMutationResult = Apollo.MutationResult<GQLAssignTaskMutation>;
export type AssignTaskMutationOptions = Apollo.BaseMutationOptions<GQLAssignTaskMutation, GQLAssignTaskMutationVariables>;
export const NewCategoryDocument = gql`
    mutation NewCategory($input: String!) {
  NewCategory(categoryName: $input) {
    success
  }
}
    `;
export type GQLNewCategoryMutationFn = Apollo.MutationFunction<GQLNewCategoryMutation, GQLNewCategoryMutationVariables>;

/**
 * __useNewCategoryMutation__
 *
 * To run a mutation, you first call `useNewCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNewCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [newCategoryMutation, { data, loading, error }] = useNewCategoryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useNewCategoryMutation(baseOptions?: Apollo.MutationHookOptions<GQLNewCategoryMutation, GQLNewCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GQLNewCategoryMutation, GQLNewCategoryMutationVariables>(NewCategoryDocument, options);
      }
export type NewCategoryMutationHookResult = ReturnType<typeof useNewCategoryMutation>;
export type NewCategoryMutationResult = Apollo.MutationResult<GQLNewCategoryMutation>;
export type NewCategoryMutationOptions = Apollo.BaseMutationOptions<GQLNewCategoryMutation, GQLNewCategoryMutationVariables>;
export const NewContentItemDocument = gql`
    mutation NewContentItem($input: NewItemParams!, $catID: ID!) {
  NewContentItem(item: $input, category: $catID) {
    success
  }
}
    `;
export type GQLNewContentItemMutationFn = Apollo.MutationFunction<GQLNewContentItemMutation, GQLNewContentItemMutationVariables>;

/**
 * __useNewContentItemMutation__
 *
 * To run a mutation, you first call `useNewContentItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNewContentItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [newContentItemMutation, { data, loading, error }] = useNewContentItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *      catID: // value for 'catID'
 *   },
 * });
 */
export function useNewContentItemMutation(baseOptions?: Apollo.MutationHookOptions<GQLNewContentItemMutation, GQLNewContentItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GQLNewContentItemMutation, GQLNewContentItemMutationVariables>(NewContentItemDocument, options);
      }
export type NewContentItemMutationHookResult = ReturnType<typeof useNewContentItemMutation>;
export type NewContentItemMutationResult = Apollo.MutationResult<GQLNewContentItemMutation>;
export type NewContentItemMutationOptions = Apollo.BaseMutationOptions<GQLNewContentItemMutation, GQLNewContentItemMutationVariables>;
export const NewTaskDocument = gql`
    mutation NewTask($input: NewTaskParams!) {
  NewTask(input: $input) {
    success
  }
}
    `;
export type GQLNewTaskMutationFn = Apollo.MutationFunction<GQLNewTaskMutation, GQLNewTaskMutationVariables>;

/**
 * __useNewTaskMutation__
 *
 * To run a mutation, you first call `useNewTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNewTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [newTaskMutation, { data, loading, error }] = useNewTaskMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useNewTaskMutation(baseOptions?: Apollo.MutationHookOptions<GQLNewTaskMutation, GQLNewTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GQLNewTaskMutation, GQLNewTaskMutationVariables>(NewTaskDocument, options);
      }
export type NewTaskMutationHookResult = ReturnType<typeof useNewTaskMutation>;
export type NewTaskMutationResult = Apollo.MutationResult<GQLNewTaskMutation>;
export type NewTaskMutationOptions = Apollo.BaseMutationOptions<GQLNewTaskMutation, GQLNewTaskMutationVariables>;
export const NewTenantRegistrationDocument = gql`
    mutation NewTenantRegistration($input: NewRegistrationParams!) {
  NewTenantRegistration(input: $input) {
    success
  }
}
    `;
export type GQLNewTenantRegistrationMutationFn = Apollo.MutationFunction<GQLNewTenantRegistrationMutation, GQLNewTenantRegistrationMutationVariables>;

/**
 * __useNewTenantRegistrationMutation__
 *
 * To run a mutation, you first call `useNewTenantRegistrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNewTenantRegistrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [newTenantRegistrationMutation, { data, loading, error }] = useNewTenantRegistrationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useNewTenantRegistrationMutation(baseOptions?: Apollo.MutationHookOptions<GQLNewTenantRegistrationMutation, GQLNewTenantRegistrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GQLNewTenantRegistrationMutation, GQLNewTenantRegistrationMutationVariables>(NewTenantRegistrationDocument, options);
      }
export type NewTenantRegistrationMutationHookResult = ReturnType<typeof useNewTenantRegistrationMutation>;
export type NewTenantRegistrationMutationResult = Apollo.MutationResult<GQLNewTenantRegistrationMutation>;
export type NewTenantRegistrationMutationOptions = Apollo.BaseMutationOptions<GQLNewTenantRegistrationMutation, GQLNewTenantRegistrationMutationVariables>;
export const NewUserDocument = gql`
    mutation NewUser($input: NewUserParams!) {
  NewUser(input: $input) {
    userID
  }
}
    `;
export type GQLNewUserMutationFn = Apollo.MutationFunction<GQLNewUserMutation, GQLNewUserMutationVariables>;

/**
 * __useNewUserMutation__
 *
 * To run a mutation, you first call `useNewUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNewUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [newUserMutation, { data, loading, error }] = useNewUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useNewUserMutation(baseOptions?: Apollo.MutationHookOptions<GQLNewUserMutation, GQLNewUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GQLNewUserMutation, GQLNewUserMutationVariables>(NewUserDocument, options);
      }
export type NewUserMutationHookResult = ReturnType<typeof useNewUserMutation>;
export type NewUserMutationResult = Apollo.MutationResult<GQLNewUserMutation>;
export type NewUserMutationOptions = Apollo.BaseMutationOptions<GQLNewUserMutation, GQLNewUserMutationVariables>;
export const RemoveCategoryDocument = gql`
    mutation RemoveCategory($categoryID: ID!) {
  RemoveCategory(categoryID: $categoryID) {
    success
  }
}
    `;
export type GQLRemoveCategoryMutationFn = Apollo.MutationFunction<GQLRemoveCategoryMutation, GQLRemoveCategoryMutationVariables>;

/**
 * __useRemoveCategoryMutation__
 *
 * To run a mutation, you first call `useRemoveCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCategoryMutation, { data, loading, error }] = useRemoveCategoryMutation({
 *   variables: {
 *      categoryID: // value for 'categoryID'
 *   },
 * });
 */
export function useRemoveCategoryMutation(baseOptions?: Apollo.MutationHookOptions<GQLRemoveCategoryMutation, GQLRemoveCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GQLRemoveCategoryMutation, GQLRemoveCategoryMutationVariables>(RemoveCategoryDocument, options);
      }
export type RemoveCategoryMutationHookResult = ReturnType<typeof useRemoveCategoryMutation>;
export type RemoveCategoryMutationResult = Apollo.MutationResult<GQLRemoveCategoryMutation>;
export type RemoveCategoryMutationOptions = Apollo.BaseMutationOptions<GQLRemoveCategoryMutation, GQLRemoveCategoryMutationVariables>;
export const RemoveContentItemDocument = gql`
    mutation RemoveContentItem($itemID: ID!) {
  RemoveContentItem(itemID: $itemID) {
    success
  }
}
    `;
export type GQLRemoveContentItemMutationFn = Apollo.MutationFunction<GQLRemoveContentItemMutation, GQLRemoveContentItemMutationVariables>;

/**
 * __useRemoveContentItemMutation__
 *
 * To run a mutation, you first call `useRemoveContentItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveContentItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeContentItemMutation, { data, loading, error }] = useRemoveContentItemMutation({
 *   variables: {
 *      itemID: // value for 'itemID'
 *   },
 * });
 */
export function useRemoveContentItemMutation(baseOptions?: Apollo.MutationHookOptions<GQLRemoveContentItemMutation, GQLRemoveContentItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GQLRemoveContentItemMutation, GQLRemoveContentItemMutationVariables>(RemoveContentItemDocument, options);
      }
export type RemoveContentItemMutationHookResult = ReturnType<typeof useRemoveContentItemMutation>;
export type RemoveContentItemMutationResult = Apollo.MutationResult<GQLRemoveContentItemMutation>;
export type RemoveContentItemMutationOptions = Apollo.BaseMutationOptions<GQLRemoveContentItemMutation, GQLRemoveContentItemMutationVariables>;
export const RemoveDraftFormDocument = gql`
    mutation RemoveDraftForm($id: ID!) {
  RemoveDraftForm(formResultID: $id) {
    success
  }
}
    `;
export type GQLRemoveDraftFormMutationFn = Apollo.MutationFunction<GQLRemoveDraftFormMutation, GQLRemoveDraftFormMutationVariables>;

/**
 * __useRemoveDraftFormMutation__
 *
 * To run a mutation, you first call `useRemoveDraftFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveDraftFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeDraftFormMutation, { data, loading, error }] = useRemoveDraftFormMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveDraftFormMutation(baseOptions?: Apollo.MutationHookOptions<GQLRemoveDraftFormMutation, GQLRemoveDraftFormMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GQLRemoveDraftFormMutation, GQLRemoveDraftFormMutationVariables>(RemoveDraftFormDocument, options);
      }
export type RemoveDraftFormMutationHookResult = ReturnType<typeof useRemoveDraftFormMutation>;
export type RemoveDraftFormMutationResult = Apollo.MutationResult<GQLRemoveDraftFormMutation>;
export type RemoveDraftFormMutationOptions = Apollo.BaseMutationOptions<GQLRemoveDraftFormMutation, GQLRemoveDraftFormMutationVariables>;
export const RequestResetPasswordDocument = gql`
    mutation RequestResetPassword($id: String!) {
  RequestResetPassword(userID: $id) {
    success
  }
}
    `;
export type GQLRequestResetPasswordMutationFn = Apollo.MutationFunction<GQLRequestResetPasswordMutation, GQLRequestResetPasswordMutationVariables>;

/**
 * __useRequestResetPasswordMutation__
 *
 * To run a mutation, you first call `useRequestResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestResetPasswordMutation, { data, loading, error }] = useRequestResetPasswordMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRequestResetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<GQLRequestResetPasswordMutation, GQLRequestResetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GQLRequestResetPasswordMutation, GQLRequestResetPasswordMutationVariables>(RequestResetPasswordDocument, options);
      }
export type RequestResetPasswordMutationHookResult = ReturnType<typeof useRequestResetPasswordMutation>;
export type RequestResetPasswordMutationResult = Apollo.MutationResult<GQLRequestResetPasswordMutation>;
export type RequestResetPasswordMutationOptions = Apollo.BaseMutationOptions<GQLRequestResetPasswordMutation, GQLRequestResetPasswordMutationVariables>;
export const SetUserPreferencesDocument = gql`
    mutation SetUserPreferences($input: JSONB!) {
  SetUserPreferences(preferences: $input) {
    success
  }
}
    `;
export type GQLSetUserPreferencesMutationFn = Apollo.MutationFunction<GQLSetUserPreferencesMutation, GQLSetUserPreferencesMutationVariables>;

/**
 * __useSetUserPreferencesMutation__
 *
 * To run a mutation, you first call `useSetUserPreferencesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetUserPreferencesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setUserPreferencesMutation, { data, loading, error }] = useSetUserPreferencesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetUserPreferencesMutation(baseOptions?: Apollo.MutationHookOptions<GQLSetUserPreferencesMutation, GQLSetUserPreferencesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GQLSetUserPreferencesMutation, GQLSetUserPreferencesMutationVariables>(SetUserPreferencesDocument, options);
      }
export type SetUserPreferencesMutationHookResult = ReturnType<typeof useSetUserPreferencesMutation>;
export type SetUserPreferencesMutationResult = Apollo.MutationResult<GQLSetUserPreferencesMutation>;
export type SetUserPreferencesMutationOptions = Apollo.BaseMutationOptions<GQLSetUserPreferencesMutation, GQLSetUserPreferencesMutationVariables>;
export const SetUserStatusDocument = gql`
    mutation SetUserStatus($id: String!, $active: Boolean!) {
  SetUserStatus(userID: $id, active: $active) {
    success
  }
}
    `;
export type GQLSetUserStatusMutationFn = Apollo.MutationFunction<GQLSetUserStatusMutation, GQLSetUserStatusMutationVariables>;

/**
 * __useSetUserStatusMutation__
 *
 * To run a mutation, you first call `useSetUserStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetUserStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setUserStatusMutation, { data, loading, error }] = useSetUserStatusMutation({
 *   variables: {
 *      id: // value for 'id'
 *      active: // value for 'active'
 *   },
 * });
 */
export function useSetUserStatusMutation(baseOptions?: Apollo.MutationHookOptions<GQLSetUserStatusMutation, GQLSetUserStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GQLSetUserStatusMutation, GQLSetUserStatusMutationVariables>(SetUserStatusDocument, options);
      }
export type SetUserStatusMutationHookResult = ReturnType<typeof useSetUserStatusMutation>;
export type SetUserStatusMutationResult = Apollo.MutationResult<GQLSetUserStatusMutation>;
export type SetUserStatusMutationOptions = Apollo.BaseMutationOptions<GQLSetUserStatusMutation, GQLSetUserStatusMutationVariables>;
export const StoreFormDocument = gql`
    mutation StoreForm($input: StoreFormParams!) {
  StoreForm(input: $input) {
    formID
    name
    description
    formSchema
    uiSchema
    defaultData
  }
}
    `;
export type GQLStoreFormMutationFn = Apollo.MutationFunction<GQLStoreFormMutation, GQLStoreFormMutationVariables>;

/**
 * __useStoreFormMutation__
 *
 * To run a mutation, you first call `useStoreFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStoreFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [storeFormMutation, { data, loading, error }] = useStoreFormMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStoreFormMutation(baseOptions?: Apollo.MutationHookOptions<GQLStoreFormMutation, GQLStoreFormMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GQLStoreFormMutation, GQLStoreFormMutationVariables>(StoreFormDocument, options);
      }
export type StoreFormMutationHookResult = ReturnType<typeof useStoreFormMutation>;
export type StoreFormMutationResult = Apollo.MutationResult<GQLStoreFormMutation>;
export type StoreFormMutationOptions = Apollo.BaseMutationOptions<GQLStoreFormMutation, GQLStoreFormMutationVariables>;
export const StoreFormResultDocument = gql`
    mutation StoreFormResult($input: ContentFormResult!) {
  StoreFormResult(input: $input)
}
    `;
export type GQLStoreFormResultMutationFn = Apollo.MutationFunction<GQLStoreFormResultMutation, GQLStoreFormResultMutationVariables>;

/**
 * __useStoreFormResultMutation__
 *
 * To run a mutation, you first call `useStoreFormResultMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStoreFormResultMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [storeFormResultMutation, { data, loading, error }] = useStoreFormResultMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStoreFormResultMutation(baseOptions?: Apollo.MutationHookOptions<GQLStoreFormResultMutation, GQLStoreFormResultMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GQLStoreFormResultMutation, GQLStoreFormResultMutationVariables>(StoreFormResultDocument, options);
      }
export type StoreFormResultMutationHookResult = ReturnType<typeof useStoreFormResultMutation>;
export type StoreFormResultMutationResult = Apollo.MutationResult<GQLStoreFormResultMutation>;
export type StoreFormResultMutationOptions = Apollo.BaseMutationOptions<GQLStoreFormResultMutation, GQLStoreFormResultMutationVariables>;
export const SubmitFormResultDocument = gql`
    mutation SubmitFormResult($id: ID!) {
  SubmitFormResult(formDataID: $id) {
    success
  }
}
    `;
export type GQLSubmitFormResultMutationFn = Apollo.MutationFunction<GQLSubmitFormResultMutation, GQLSubmitFormResultMutationVariables>;

/**
 * __useSubmitFormResultMutation__
 *
 * To run a mutation, you first call `useSubmitFormResultMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitFormResultMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitFormResultMutation, { data, loading, error }] = useSubmitFormResultMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSubmitFormResultMutation(baseOptions?: Apollo.MutationHookOptions<GQLSubmitFormResultMutation, GQLSubmitFormResultMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GQLSubmitFormResultMutation, GQLSubmitFormResultMutationVariables>(SubmitFormResultDocument, options);
      }
export type SubmitFormResultMutationHookResult = ReturnType<typeof useSubmitFormResultMutation>;
export type SubmitFormResultMutationResult = Apollo.MutationResult<GQLSubmitFormResultMutation>;
export type SubmitFormResultMutationOptions = Apollo.BaseMutationOptions<GQLSubmitFormResultMutation, GQLSubmitFormResultMutationVariables>;
export const TaskNewCommentDocument = gql`
    mutation TaskNewComment($input: TaskNewCommentParams!) {
  TaskNewComment(input: $input) {
    success
  }
}
    `;
export type GQLTaskNewCommentMutationFn = Apollo.MutationFunction<GQLTaskNewCommentMutation, GQLTaskNewCommentMutationVariables>;

/**
 * __useTaskNewCommentMutation__
 *
 * To run a mutation, you first call `useTaskNewCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTaskNewCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [taskNewCommentMutation, { data, loading, error }] = useTaskNewCommentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTaskNewCommentMutation(baseOptions?: Apollo.MutationHookOptions<GQLTaskNewCommentMutation, GQLTaskNewCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GQLTaskNewCommentMutation, GQLTaskNewCommentMutationVariables>(TaskNewCommentDocument, options);
      }
export type TaskNewCommentMutationHookResult = ReturnType<typeof useTaskNewCommentMutation>;
export type TaskNewCommentMutationResult = Apollo.MutationResult<GQLTaskNewCommentMutation>;
export type TaskNewCommentMutationOptions = Apollo.BaseMutationOptions<GQLTaskNewCommentMutation, GQLTaskNewCommentMutationVariables>;
export const TenantRegistrationCreateAdminDocument = gql`
    mutation TenantRegistrationCreateAdmin($id: ID!) {
  TenantRegistrationCreateAdmin(registrationID: $id) {
    success
  }
}
    `;
export type GQLTenantRegistrationCreateAdminMutationFn = Apollo.MutationFunction<GQLTenantRegistrationCreateAdminMutation, GQLTenantRegistrationCreateAdminMutationVariables>;

/**
 * __useTenantRegistrationCreateAdminMutation__
 *
 * To run a mutation, you first call `useTenantRegistrationCreateAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTenantRegistrationCreateAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [tenantRegistrationCreateAdminMutation, { data, loading, error }] = useTenantRegistrationCreateAdminMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTenantRegistrationCreateAdminMutation(baseOptions?: Apollo.MutationHookOptions<GQLTenantRegistrationCreateAdminMutation, GQLTenantRegistrationCreateAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GQLTenantRegistrationCreateAdminMutation, GQLTenantRegistrationCreateAdminMutationVariables>(TenantRegistrationCreateAdminDocument, options);
      }
export type TenantRegistrationCreateAdminMutationHookResult = ReturnType<typeof useTenantRegistrationCreateAdminMutation>;
export type TenantRegistrationCreateAdminMutationResult = Apollo.MutationResult<GQLTenantRegistrationCreateAdminMutation>;
export type TenantRegistrationCreateAdminMutationOptions = Apollo.BaseMutationOptions<GQLTenantRegistrationCreateAdminMutation, GQLTenantRegistrationCreateAdminMutationVariables>;
export const TenantRegistrationSetStatusDocument = gql`
    mutation TenantRegistrationSetStatus($registrationID: ID!, $status: RegistrationStatus!) {
  TenantRegistrationSetStatus(registrationID: $registrationID, status: $status) {
    success
  }
}
    `;
export type GQLTenantRegistrationSetStatusMutationFn = Apollo.MutationFunction<GQLTenantRegistrationSetStatusMutation, GQLTenantRegistrationSetStatusMutationVariables>;

/**
 * __useTenantRegistrationSetStatusMutation__
 *
 * To run a mutation, you first call `useTenantRegistrationSetStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTenantRegistrationSetStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [tenantRegistrationSetStatusMutation, { data, loading, error }] = useTenantRegistrationSetStatusMutation({
 *   variables: {
 *      registrationID: // value for 'registrationID'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useTenantRegistrationSetStatusMutation(baseOptions?: Apollo.MutationHookOptions<GQLTenantRegistrationSetStatusMutation, GQLTenantRegistrationSetStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GQLTenantRegistrationSetStatusMutation, GQLTenantRegistrationSetStatusMutationVariables>(TenantRegistrationSetStatusDocument, options);
      }
export type TenantRegistrationSetStatusMutationHookResult = ReturnType<typeof useTenantRegistrationSetStatusMutation>;
export type TenantRegistrationSetStatusMutationResult = Apollo.MutationResult<GQLTenantRegistrationSetStatusMutation>;
export type TenantRegistrationSetStatusMutationOptions = Apollo.BaseMutationOptions<GQLTenantRegistrationSetStatusMutation, GQLTenantRegistrationSetStatusMutationVariables>;
export const TenantSetStatusDocument = gql`
    mutation TenantSetStatus($input: TenantSetStatusParams!) {
  TenantSetStatus(input: $input) {
    success
  }
}
    `;
export type GQLTenantSetStatusMutationFn = Apollo.MutationFunction<GQLTenantSetStatusMutation, GQLTenantSetStatusMutationVariables>;

/**
 * __useTenantSetStatusMutation__
 *
 * To run a mutation, you first call `useTenantSetStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTenantSetStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [tenantSetStatusMutation, { data, loading, error }] = useTenantSetStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTenantSetStatusMutation(baseOptions?: Apollo.MutationHookOptions<GQLTenantSetStatusMutation, GQLTenantSetStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GQLTenantSetStatusMutation, GQLTenantSetStatusMutationVariables>(TenantSetStatusDocument, options);
      }
export type TenantSetStatusMutationHookResult = ReturnType<typeof useTenantSetStatusMutation>;
export type TenantSetStatusMutationResult = Apollo.MutationResult<GQLTenantSetStatusMutation>;
export type TenantSetStatusMutationOptions = Apollo.BaseMutationOptions<GQLTenantSetStatusMutation, GQLTenantSetStatusMutationVariables>;
export const UpdateCategoryNameDocument = gql`
    mutation UpdateCategoryName($input: UpdateCategoryNameParams!) {
  UpdateCategoryName(input: $input) {
    success
  }
}
    `;
export type GQLUpdateCategoryNameMutationFn = Apollo.MutationFunction<GQLUpdateCategoryNameMutation, GQLUpdateCategoryNameMutationVariables>;

/**
 * __useUpdateCategoryNameMutation__
 *
 * To run a mutation, you first call `useUpdateCategoryNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCategoryNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCategoryNameMutation, { data, loading, error }] = useUpdateCategoryNameMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCategoryNameMutation(baseOptions?: Apollo.MutationHookOptions<GQLUpdateCategoryNameMutation, GQLUpdateCategoryNameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GQLUpdateCategoryNameMutation, GQLUpdateCategoryNameMutationVariables>(UpdateCategoryNameDocument, options);
      }
export type UpdateCategoryNameMutationHookResult = ReturnType<typeof useUpdateCategoryNameMutation>;
export type UpdateCategoryNameMutationResult = Apollo.MutationResult<GQLUpdateCategoryNameMutation>;
export type UpdateCategoryNameMutationOptions = Apollo.BaseMutationOptions<GQLUpdateCategoryNameMutation, GQLUpdateCategoryNameMutationVariables>;
export const UpdateContentItemRolesDocument = gql`
    mutation UpdateContentItemRoles($input: UpdateContentItemRoleParams) {
  UpdateContentItemRoles(input: $input) {
    success
  }
}
    `;
export type GQLUpdateContentItemRolesMutationFn = Apollo.MutationFunction<GQLUpdateContentItemRolesMutation, GQLUpdateContentItemRolesMutationVariables>;

/**
 * __useUpdateContentItemRolesMutation__
 *
 * To run a mutation, you first call `useUpdateContentItemRolesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContentItemRolesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContentItemRolesMutation, { data, loading, error }] = useUpdateContentItemRolesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateContentItemRolesMutation(baseOptions?: Apollo.MutationHookOptions<GQLUpdateContentItemRolesMutation, GQLUpdateContentItemRolesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GQLUpdateContentItemRolesMutation, GQLUpdateContentItemRolesMutationVariables>(UpdateContentItemRolesDocument, options);
      }
export type UpdateContentItemRolesMutationHookResult = ReturnType<typeof useUpdateContentItemRolesMutation>;
export type UpdateContentItemRolesMutationResult = Apollo.MutationResult<GQLUpdateContentItemRolesMutation>;
export type UpdateContentItemRolesMutationOptions = Apollo.BaseMutationOptions<GQLUpdateContentItemRolesMutation, GQLUpdateContentItemRolesMutationVariables>;
export const UpdateCustomEnabledFormsDocument = gql`
    mutation UpdateCustomEnabledForms($input: [UpdateCustomFormEnabledParams!]!) {
  UpdateCustomEnabledForms(input: $input) {
    success
  }
}
    `;
export type GQLUpdateCustomEnabledFormsMutationFn = Apollo.MutationFunction<GQLUpdateCustomEnabledFormsMutation, GQLUpdateCustomEnabledFormsMutationVariables>;

/**
 * __useUpdateCustomEnabledFormsMutation__
 *
 * To run a mutation, you first call `useUpdateCustomEnabledFormsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomEnabledFormsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomEnabledFormsMutation, { data, loading, error }] = useUpdateCustomEnabledFormsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCustomEnabledFormsMutation(baseOptions?: Apollo.MutationHookOptions<GQLUpdateCustomEnabledFormsMutation, GQLUpdateCustomEnabledFormsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GQLUpdateCustomEnabledFormsMutation, GQLUpdateCustomEnabledFormsMutationVariables>(UpdateCustomEnabledFormsDocument, options);
      }
export type UpdateCustomEnabledFormsMutationHookResult = ReturnType<typeof useUpdateCustomEnabledFormsMutation>;
export type UpdateCustomEnabledFormsMutationResult = Apollo.MutationResult<GQLUpdateCustomEnabledFormsMutation>;
export type UpdateCustomEnabledFormsMutationOptions = Apollo.BaseMutationOptions<GQLUpdateCustomEnabledFormsMutation, GQLUpdateCustomEnabledFormsMutationVariables>;
export const UpdateEnabledFormsDocument = gql`
    mutation UpdateEnabledForms($ids: [Int!]!) {
  UpdateEnabledForms(formIDs: $ids) {
    success
  }
}
    `;
export type GQLUpdateEnabledFormsMutationFn = Apollo.MutationFunction<GQLUpdateEnabledFormsMutation, GQLUpdateEnabledFormsMutationVariables>;

/**
 * __useUpdateEnabledFormsMutation__
 *
 * To run a mutation, you first call `useUpdateEnabledFormsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEnabledFormsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEnabledFormsMutation, { data, loading, error }] = useUpdateEnabledFormsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useUpdateEnabledFormsMutation(baseOptions?: Apollo.MutationHookOptions<GQLUpdateEnabledFormsMutation, GQLUpdateEnabledFormsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GQLUpdateEnabledFormsMutation, GQLUpdateEnabledFormsMutationVariables>(UpdateEnabledFormsDocument, options);
      }
export type UpdateEnabledFormsMutationHookResult = ReturnType<typeof useUpdateEnabledFormsMutation>;
export type UpdateEnabledFormsMutationResult = Apollo.MutationResult<GQLUpdateEnabledFormsMutation>;
export type UpdateEnabledFormsMutationOptions = Apollo.BaseMutationOptions<GQLUpdateEnabledFormsMutation, GQLUpdateEnabledFormsMutationVariables>;
export const UpdateFormEnabledDocument = gql`
    mutation UpdateFormEnabled($input: UpdateFormEnabledParams!, $customForm: Boolean!) {
  UpdateFormEnabled(input: $input, customForm: $customForm) {
    success
  }
}
    `;
export type GQLUpdateFormEnabledMutationFn = Apollo.MutationFunction<GQLUpdateFormEnabledMutation, GQLUpdateFormEnabledMutationVariables>;

/**
 * __useUpdateFormEnabledMutation__
 *
 * To run a mutation, you first call `useUpdateFormEnabledMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFormEnabledMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFormEnabledMutation, { data, loading, error }] = useUpdateFormEnabledMutation({
 *   variables: {
 *      input: // value for 'input'
 *      customForm: // value for 'customForm'
 *   },
 * });
 */
export function useUpdateFormEnabledMutation(baseOptions?: Apollo.MutationHookOptions<GQLUpdateFormEnabledMutation, GQLUpdateFormEnabledMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GQLUpdateFormEnabledMutation, GQLUpdateFormEnabledMutationVariables>(UpdateFormEnabledDocument, options);
      }
export type UpdateFormEnabledMutationHookResult = ReturnType<typeof useUpdateFormEnabledMutation>;
export type UpdateFormEnabledMutationResult = Apollo.MutationResult<GQLUpdateFormEnabledMutation>;
export type UpdateFormEnabledMutationOptions = Apollo.BaseMutationOptions<GQLUpdateFormEnabledMutation, GQLUpdateFormEnabledMutationVariables>;
export const UpdateTaskDocument = gql`
    mutation UpdateTask($input: UpdateTaskParams!) {
  UpdateTask(input: $input) {
    success
  }
}
    `;
export type GQLUpdateTaskMutationFn = Apollo.MutationFunction<GQLUpdateTaskMutation, GQLUpdateTaskMutationVariables>;

/**
 * __useUpdateTaskMutation__
 *
 * To run a mutation, you first call `useUpdateTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTaskMutation, { data, loading, error }] = useUpdateTaskMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTaskMutation(baseOptions?: Apollo.MutationHookOptions<GQLUpdateTaskMutation, GQLUpdateTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GQLUpdateTaskMutation, GQLUpdateTaskMutationVariables>(UpdateTaskDocument, options);
      }
export type UpdateTaskMutationHookResult = ReturnType<typeof useUpdateTaskMutation>;
export type UpdateTaskMutationResult = Apollo.MutationResult<GQLUpdateTaskMutation>;
export type UpdateTaskMutationOptions = Apollo.BaseMutationOptions<GQLUpdateTaskMutation, GQLUpdateTaskMutationVariables>;
export const UpdateTaskStatusDocument = gql`
    mutation UpdateTaskStatus($input: UpdateTaskStatusParams!) {
  UpdateTaskStatus(input: $input) {
    success
  }
}
    `;
export type GQLUpdateTaskStatusMutationFn = Apollo.MutationFunction<GQLUpdateTaskStatusMutation, GQLUpdateTaskStatusMutationVariables>;

/**
 * __useUpdateTaskStatusMutation__
 *
 * To run a mutation, you first call `useUpdateTaskStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTaskStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTaskStatusMutation, { data, loading, error }] = useUpdateTaskStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTaskStatusMutation(baseOptions?: Apollo.MutationHookOptions<GQLUpdateTaskStatusMutation, GQLUpdateTaskStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GQLUpdateTaskStatusMutation, GQLUpdateTaskStatusMutationVariables>(UpdateTaskStatusDocument, options);
      }
export type UpdateTaskStatusMutationHookResult = ReturnType<typeof useUpdateTaskStatusMutation>;
export type UpdateTaskStatusMutationResult = Apollo.MutationResult<GQLUpdateTaskStatusMutation>;
export type UpdateTaskStatusMutationOptions = Apollo.BaseMutationOptions<GQLUpdateTaskStatusMutation, GQLUpdateTaskStatusMutationVariables>;
export const UpdateTenantFormPartsByFormIdDocument = gql`
    mutation UpdateTenantFormPartsByFormID($formID: ID!, $formParts: [String!]!) {
  UpdateTenantFormPartsByFormID(formID: $formID, formParts: $formParts) {
    success
  }
}
    `;
export type GQLUpdateTenantFormPartsByFormIdMutationFn = Apollo.MutationFunction<GQLUpdateTenantFormPartsByFormIdMutation, GQLUpdateTenantFormPartsByFormIdMutationVariables>;

/**
 * __useUpdateTenantFormPartsByFormIdMutation__
 *
 * To run a mutation, you first call `useUpdateTenantFormPartsByFormIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTenantFormPartsByFormIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTenantFormPartsByFormIdMutation, { data, loading, error }] = useUpdateTenantFormPartsByFormIdMutation({
 *   variables: {
 *      formID: // value for 'formID'
 *      formParts: // value for 'formParts'
 *   },
 * });
 */
export function useUpdateTenantFormPartsByFormIdMutation(baseOptions?: Apollo.MutationHookOptions<GQLUpdateTenantFormPartsByFormIdMutation, GQLUpdateTenantFormPartsByFormIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GQLUpdateTenantFormPartsByFormIdMutation, GQLUpdateTenantFormPartsByFormIdMutationVariables>(UpdateTenantFormPartsByFormIdDocument, options);
      }
export type UpdateTenantFormPartsByFormIdMutationHookResult = ReturnType<typeof useUpdateTenantFormPartsByFormIdMutation>;
export type UpdateTenantFormPartsByFormIdMutationResult = Apollo.MutationResult<GQLUpdateTenantFormPartsByFormIdMutation>;
export type UpdateTenantFormPartsByFormIdMutationOptions = Apollo.BaseMutationOptions<GQLUpdateTenantFormPartsByFormIdMutation, GQLUpdateTenantFormPartsByFormIdMutationVariables>;
export const UpdateTenantOrganizationDocument = gql`
    mutation UpdateTenantOrganization($tenantInput: UpdateTenantParams!, $organizationInput: UpdateOrganizationParams!) {
  UpdateTenantOrganization(
    tenantInput: $tenantInput
    organiztionInput: $organizationInput
  ) {
    success
  }
}
    `;
export type GQLUpdateTenantOrganizationMutationFn = Apollo.MutationFunction<GQLUpdateTenantOrganizationMutation, GQLUpdateTenantOrganizationMutationVariables>;

/**
 * __useUpdateTenantOrganizationMutation__
 *
 * To run a mutation, you first call `useUpdateTenantOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTenantOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTenantOrganizationMutation, { data, loading, error }] = useUpdateTenantOrganizationMutation({
 *   variables: {
 *      tenantInput: // value for 'tenantInput'
 *      organizationInput: // value for 'organizationInput'
 *   },
 * });
 */
export function useUpdateTenantOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<GQLUpdateTenantOrganizationMutation, GQLUpdateTenantOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GQLUpdateTenantOrganizationMutation, GQLUpdateTenantOrganizationMutationVariables>(UpdateTenantOrganizationDocument, options);
      }
export type UpdateTenantOrganizationMutationHookResult = ReturnType<typeof useUpdateTenantOrganizationMutation>;
export type UpdateTenantOrganizationMutationResult = Apollo.MutationResult<GQLUpdateTenantOrganizationMutation>;
export type UpdateTenantOrganizationMutationOptions = Apollo.BaseMutationOptions<GQLUpdateTenantOrganizationMutation, GQLUpdateTenantOrganizationMutationVariables>;
export const UpdateTenantRegistrationDocument = gql`
    mutation UpdateTenantRegistration($input: UpdateRegistrationParams!) {
  UpdateTenantRegistration(input: $input) {
    success
  }
}
    `;
export type GQLUpdateTenantRegistrationMutationFn = Apollo.MutationFunction<GQLUpdateTenantRegistrationMutation, GQLUpdateTenantRegistrationMutationVariables>;

/**
 * __useUpdateTenantRegistrationMutation__
 *
 * To run a mutation, you first call `useUpdateTenantRegistrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTenantRegistrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTenantRegistrationMutation, { data, loading, error }] = useUpdateTenantRegistrationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTenantRegistrationMutation(baseOptions?: Apollo.MutationHookOptions<GQLUpdateTenantRegistrationMutation, GQLUpdateTenantRegistrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GQLUpdateTenantRegistrationMutation, GQLUpdateTenantRegistrationMutationVariables>(UpdateTenantRegistrationDocument, options);
      }
export type UpdateTenantRegistrationMutationHookResult = ReturnType<typeof useUpdateTenantRegistrationMutation>;
export type UpdateTenantRegistrationMutationResult = Apollo.MutationResult<GQLUpdateTenantRegistrationMutation>;
export type UpdateTenantRegistrationMutationOptions = Apollo.BaseMutationOptions<GQLUpdateTenantRegistrationMutation, GQLUpdateTenantRegistrationMutationVariables>;
export const UpdateTranslationDocument = gql`
    mutation updateTranslation($input: UpdateTranslationParams!) {
  UpdateTranslation(input: $input) {
    success
  }
}
    `;
export type GQLUpdateTranslationMutationFn = Apollo.MutationFunction<GQLUpdateTranslationMutation, GQLUpdateTranslationMutationVariables>;

/**
 * __useUpdateTranslationMutation__
 *
 * To run a mutation, you first call `useUpdateTranslationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTranslationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTranslationMutation, { data, loading, error }] = useUpdateTranslationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTranslationMutation(baseOptions?: Apollo.MutationHookOptions<GQLUpdateTranslationMutation, GQLUpdateTranslationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GQLUpdateTranslationMutation, GQLUpdateTranslationMutationVariables>(UpdateTranslationDocument, options);
      }
export type UpdateTranslationMutationHookResult = ReturnType<typeof useUpdateTranslationMutation>;
export type UpdateTranslationMutationResult = Apollo.MutationResult<GQLUpdateTranslationMutation>;
export type UpdateTranslationMutationOptions = Apollo.BaseMutationOptions<GQLUpdateTranslationMutation, GQLUpdateTranslationMutationVariables>;
export const UpdateUserByIdDocument = gql`
    mutation UpdateUserByID($input: UpdateUserByIDParams!) {
  UpdateUserByID(input: $input) {
    success
  }
}
    `;
export type GQLUpdateUserByIdMutationFn = Apollo.MutationFunction<GQLUpdateUserByIdMutation, GQLUpdateUserByIdMutationVariables>;

/**
 * __useUpdateUserByIdMutation__
 *
 * To run a mutation, you first call `useUpdateUserByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserByIdMutation, { data, loading, error }] = useUpdateUserByIdMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserByIdMutation(baseOptions?: Apollo.MutationHookOptions<GQLUpdateUserByIdMutation, GQLUpdateUserByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GQLUpdateUserByIdMutation, GQLUpdateUserByIdMutationVariables>(UpdateUserByIdDocument, options);
      }
export type UpdateUserByIdMutationHookResult = ReturnType<typeof useUpdateUserByIdMutation>;
export type UpdateUserByIdMutationResult = Apollo.MutationResult<GQLUpdateUserByIdMutation>;
export type UpdateUserByIdMutationOptions = Apollo.BaseMutationOptions<GQLUpdateUserByIdMutation, GQLUpdateUserByIdMutationVariables>;
export const CurrentUserDocument = gql`
    query CurrentUser {
  currentUser {
    emailAddress
    userID
    roles {
      roleID
      roleName
      description
    }
    active
    preferences
    avatar
    permissions
    firstName
    infix
    lastName
    tenantID
    tenantDetails {
      name
      logo
      config
    }
  }
}
    `;

/**
 * __useCurrentUserQuery__
 *
 * To run a query within a React component, call `useCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserQuery(baseOptions?: Apollo.QueryHookOptions<GQLCurrentUserQuery, GQLCurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GQLCurrentUserQuery, GQLCurrentUserQueryVariables>(CurrentUserDocument, options);
      }
export function useCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GQLCurrentUserQuery, GQLCurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GQLCurrentUserQuery, GQLCurrentUserQueryVariables>(CurrentUserDocument, options);
        }
export type CurrentUserQueryHookResult = ReturnType<typeof useCurrentUserQuery>;
export type CurrentUserLazyQueryHookResult = ReturnType<typeof useCurrentUserLazyQuery>;
export type CurrentUserQueryResult = Apollo.QueryResult<GQLCurrentUserQuery, GQLCurrentUserQueryVariables>;
export const GetEnabledFormsDocument = gql`
    query GetEnabledForms {
  EnabledForms {
    formID
    formVersion
    name
    description
    defaultData
  }
}
    `;

/**
 * __useGetEnabledFormsQuery__
 *
 * To run a query within a React component, call `useGetEnabledFormsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEnabledFormsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEnabledFormsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetEnabledFormsQuery(baseOptions?: Apollo.QueryHookOptions<GQLGetEnabledFormsQuery, GQLGetEnabledFormsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GQLGetEnabledFormsQuery, GQLGetEnabledFormsQueryVariables>(GetEnabledFormsDocument, options);
      }
export function useGetEnabledFormsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GQLGetEnabledFormsQuery, GQLGetEnabledFormsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GQLGetEnabledFormsQuery, GQLGetEnabledFormsQueryVariables>(GetEnabledFormsDocument, options);
        }
export type GetEnabledFormsQueryHookResult = ReturnType<typeof useGetEnabledFormsQuery>;
export type GetEnabledFormsLazyQueryHookResult = ReturnType<typeof useGetEnabledFormsLazyQuery>;
export type GetEnabledFormsQueryResult = Apollo.QueryResult<GQLGetEnabledFormsQuery, GQLGetEnabledFormsQueryVariables>;
export const FormByIdDocument = gql`
    query FormByID($formID: ID!) {
  FormByID(formID: $formID) {
    formID
    formVersion
    name
    description
    formSchema
    uiSchema
    defaultData
  }
}
    `;

/**
 * __useFormByIdQuery__
 *
 * To run a query within a React component, call `useFormByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFormByIdQuery({
 *   variables: {
 *      formID: // value for 'formID'
 *   },
 * });
 */
export function useFormByIdQuery(baseOptions: Apollo.QueryHookOptions<GQLFormByIdQuery, GQLFormByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GQLFormByIdQuery, GQLFormByIdQueryVariables>(FormByIdDocument, options);
      }
export function useFormByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GQLFormByIdQuery, GQLFormByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GQLFormByIdQuery, GQLFormByIdQueryVariables>(FormByIdDocument, options);
        }
export type FormByIdQueryHookResult = ReturnType<typeof useFormByIdQuery>;
export type FormByIdLazyQueryHookResult = ReturnType<typeof useFormByIdLazyQuery>;
export type FormByIdQueryResult = Apollo.QueryResult<GQLFormByIdQuery, GQLFormByIdQueryVariables>;
export const FormDesignerByIdDocument = gql`
    query FormDesignerByID($formID: ID!) {
  FormDesignerByID(formID: $formID) {
    formID
    formVersion
    name
    description
    formSchema
    uiSchema
    defaultData
  }
}
    `;

/**
 * __useFormDesignerByIdQuery__
 *
 * To run a query within a React component, call `useFormDesignerByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormDesignerByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFormDesignerByIdQuery({
 *   variables: {
 *      formID: // value for 'formID'
 *   },
 * });
 */
export function useFormDesignerByIdQuery(baseOptions: Apollo.QueryHookOptions<GQLFormDesignerByIdQuery, GQLFormDesignerByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GQLFormDesignerByIdQuery, GQLFormDesignerByIdQueryVariables>(FormDesignerByIdDocument, options);
      }
export function useFormDesignerByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GQLFormDesignerByIdQuery, GQLFormDesignerByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GQLFormDesignerByIdQuery, GQLFormDesignerByIdQueryVariables>(FormDesignerByIdDocument, options);
        }
export type FormDesignerByIdQueryHookResult = ReturnType<typeof useFormDesignerByIdQuery>;
export type FormDesignerByIdLazyQueryHookResult = ReturnType<typeof useFormDesignerByIdLazyQuery>;
export type FormDesignerByIdQueryResult = Apollo.QueryResult<GQLFormDesignerByIdQuery, GQLFormDesignerByIdQueryVariables>;
export const GetAllUserTenantsDocument = gql`
    query GetAllUserTenants {
  AllUserTenants {
    name
    TenantID
  }
}
    `;

/**
 * __useGetAllUserTenantsQuery__
 *
 * To run a query within a React component, call `useGetAllUserTenantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllUserTenantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllUserTenantsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllUserTenantsQuery(baseOptions?: Apollo.QueryHookOptions<GQLGetAllUserTenantsQuery, GQLGetAllUserTenantsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GQLGetAllUserTenantsQuery, GQLGetAllUserTenantsQueryVariables>(GetAllUserTenantsDocument, options);
      }
export function useGetAllUserTenantsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GQLGetAllUserTenantsQuery, GQLGetAllUserTenantsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GQLGetAllUserTenantsQuery, GQLGetAllUserTenantsQueryVariables>(GetAllUserTenantsDocument, options);
        }
export type GetAllUserTenantsQueryHookResult = ReturnType<typeof useGetAllUserTenantsQuery>;
export type GetAllUserTenantsLazyQueryHookResult = ReturnType<typeof useGetAllUserTenantsLazyQuery>;
export type GetAllUserTenantsQueryResult = Apollo.QueryResult<GQLGetAllUserTenantsQuery, GQLGetAllUserTenantsQueryVariables>;
export const GetAvailableFormsDocument = gql`
    query GetAvailableForms {
  AvailableForms {
    name
    formID
    description
    enabled
    customForm
  }
}
    `;

/**
 * __useGetAvailableFormsQuery__
 *
 * To run a query within a React component, call `useGetAvailableFormsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAvailableFormsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAvailableFormsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAvailableFormsQuery(baseOptions?: Apollo.QueryHookOptions<GQLGetAvailableFormsQuery, GQLGetAvailableFormsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GQLGetAvailableFormsQuery, GQLGetAvailableFormsQueryVariables>(GetAvailableFormsDocument, options);
      }
export function useGetAvailableFormsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GQLGetAvailableFormsQuery, GQLGetAvailableFormsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GQLGetAvailableFormsQuery, GQLGetAvailableFormsQueryVariables>(GetAvailableFormsDocument, options);
        }
export type GetAvailableFormsQueryHookResult = ReturnType<typeof useGetAvailableFormsQuery>;
export type GetAvailableFormsLazyQueryHookResult = ReturnType<typeof useGetAvailableFormsLazyQuery>;
export type GetAvailableFormsQueryResult = Apollo.QueryResult<GQLGetAvailableFormsQuery, GQLGetAvailableFormsQueryVariables>;
export const GetCategoryStructureDocument = gql`
    query GetCategoryStructure {
  CategoryStructure {
    categoryID
    name
    children {
      categoryID
      name
    }
    items {
      itemID
      name
      description
      createdAt
      createdBy
      sensitivityLevel
      deleted
      mimetype
      downloadUrl
      roles
    }
  }
}
    `;

/**
 * __useGetCategoryStructureQuery__
 *
 * To run a query within a React component, call `useGetCategoryStructureQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCategoryStructureQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCategoryStructureQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCategoryStructureQuery(baseOptions?: Apollo.QueryHookOptions<GQLGetCategoryStructureQuery, GQLGetCategoryStructureQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GQLGetCategoryStructureQuery, GQLGetCategoryStructureQueryVariables>(GetCategoryStructureDocument, options);
      }
export function useGetCategoryStructureLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GQLGetCategoryStructureQuery, GQLGetCategoryStructureQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GQLGetCategoryStructureQuery, GQLGetCategoryStructureQueryVariables>(GetCategoryStructureDocument, options);
        }
export type GetCategoryStructureQueryHookResult = ReturnType<typeof useGetCategoryStructureQuery>;
export type GetCategoryStructureLazyQueryHookResult = ReturnType<typeof useGetCategoryStructureLazyQuery>;
export type GetCategoryStructureQueryResult = Apollo.QueryResult<GQLGetCategoryStructureQuery, GQLGetCategoryStructureQueryVariables>;
export const GetContentItemsByCategoryIdDocument = gql`
    query GetContentItemsByCategoryID($id: ID!) {
  ContentItemsByCategoryID(categoryID: $id) {
    itemID
    name
    description
    createdAt
    createdBy
    sensitivityLevel
    deleted
    roles
    mimetype
  }
}
    `;

/**
 * __useGetContentItemsByCategoryIdQuery__
 *
 * To run a query within a React component, call `useGetContentItemsByCategoryIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContentItemsByCategoryIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContentItemsByCategoryIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetContentItemsByCategoryIdQuery(baseOptions: Apollo.QueryHookOptions<GQLGetContentItemsByCategoryIdQuery, GQLGetContentItemsByCategoryIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GQLGetContentItemsByCategoryIdQuery, GQLGetContentItemsByCategoryIdQueryVariables>(GetContentItemsByCategoryIdDocument, options);
      }
export function useGetContentItemsByCategoryIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GQLGetContentItemsByCategoryIdQuery, GQLGetContentItemsByCategoryIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GQLGetContentItemsByCategoryIdQuery, GQLGetContentItemsByCategoryIdQueryVariables>(GetContentItemsByCategoryIdDocument, options);
        }
export type GetContentItemsByCategoryIdQueryHookResult = ReturnType<typeof useGetContentItemsByCategoryIdQuery>;
export type GetContentItemsByCategoryIdLazyQueryHookResult = ReturnType<typeof useGetContentItemsByCategoryIdLazyQuery>;
export type GetContentItemsByCategoryIdQueryResult = Apollo.QueryResult<GQLGetContentItemsByCategoryIdQuery, GQLGetContentItemsByCategoryIdQueryVariables>;
export const GetDisabledTenantFormPartsByFormIdDocument = gql`
    query GetDisabledTenantFormPartsByFormID($formID: ID!) {
  DisabledTenantFormPartsByFormID(formID: $formID) {
    name
    formPartID
    formID
  }
}
    `;

/**
 * __useGetDisabledTenantFormPartsByFormIdQuery__
 *
 * To run a query within a React component, call `useGetDisabledTenantFormPartsByFormIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDisabledTenantFormPartsByFormIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDisabledTenantFormPartsByFormIdQuery({
 *   variables: {
 *      formID: // value for 'formID'
 *   },
 * });
 */
export function useGetDisabledTenantFormPartsByFormIdQuery(baseOptions: Apollo.QueryHookOptions<GQLGetDisabledTenantFormPartsByFormIdQuery, GQLGetDisabledTenantFormPartsByFormIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GQLGetDisabledTenantFormPartsByFormIdQuery, GQLGetDisabledTenantFormPartsByFormIdQueryVariables>(GetDisabledTenantFormPartsByFormIdDocument, options);
      }
export function useGetDisabledTenantFormPartsByFormIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GQLGetDisabledTenantFormPartsByFormIdQuery, GQLGetDisabledTenantFormPartsByFormIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GQLGetDisabledTenantFormPartsByFormIdQuery, GQLGetDisabledTenantFormPartsByFormIdQueryVariables>(GetDisabledTenantFormPartsByFormIdDocument, options);
        }
export type GetDisabledTenantFormPartsByFormIdQueryHookResult = ReturnType<typeof useGetDisabledTenantFormPartsByFormIdQuery>;
export type GetDisabledTenantFormPartsByFormIdLazyQueryHookResult = ReturnType<typeof useGetDisabledTenantFormPartsByFormIdLazyQuery>;
export type GetDisabledTenantFormPartsByFormIdQueryResult = Apollo.QueryResult<GQLGetDisabledTenantFormPartsByFormIdQuery, GQLGetDisabledTenantFormPartsByFormIdQueryVariables>;
export const GetDisabledTenantFormsDocument = gql`
    query GetDisabledTenantForms {
  DisabledTenantForms {
    name
    formID
    customForm
  }
}
    `;

/**
 * __useGetDisabledTenantFormsQuery__
 *
 * To run a query within a React component, call `useGetDisabledTenantFormsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDisabledTenantFormsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDisabledTenantFormsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDisabledTenantFormsQuery(baseOptions?: Apollo.QueryHookOptions<GQLGetDisabledTenantFormsQuery, GQLGetDisabledTenantFormsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GQLGetDisabledTenantFormsQuery, GQLGetDisabledTenantFormsQueryVariables>(GetDisabledTenantFormsDocument, options);
      }
export function useGetDisabledTenantFormsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GQLGetDisabledTenantFormsQuery, GQLGetDisabledTenantFormsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GQLGetDisabledTenantFormsQuery, GQLGetDisabledTenantFormsQueryVariables>(GetDisabledTenantFormsDocument, options);
        }
export type GetDisabledTenantFormsQueryHookResult = ReturnType<typeof useGetDisabledTenantFormsQuery>;
export type GetDisabledTenantFormsLazyQueryHookResult = ReturnType<typeof useGetDisabledTenantFormsLazyQuery>;
export type GetDisabledTenantFormsQueryResult = Apollo.QueryResult<GQLGetDisabledTenantFormsQuery, GQLGetDisabledTenantFormsQueryVariables>;
export const GetEnabledTenantFormPartsByFormIdDocument = gql`
    query GetEnabledTenantFormPartsByFormID($formID: ID!) {
  EnabledTenantFormPartsByFormID(formID: $formID) {
    name
    formPartID
    formID
  }
}
    `;

/**
 * __useGetEnabledTenantFormPartsByFormIdQuery__
 *
 * To run a query within a React component, call `useGetEnabledTenantFormPartsByFormIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEnabledTenantFormPartsByFormIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEnabledTenantFormPartsByFormIdQuery({
 *   variables: {
 *      formID: // value for 'formID'
 *   },
 * });
 */
export function useGetEnabledTenantFormPartsByFormIdQuery(baseOptions: Apollo.QueryHookOptions<GQLGetEnabledTenantFormPartsByFormIdQuery, GQLGetEnabledTenantFormPartsByFormIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GQLGetEnabledTenantFormPartsByFormIdQuery, GQLGetEnabledTenantFormPartsByFormIdQueryVariables>(GetEnabledTenantFormPartsByFormIdDocument, options);
      }
export function useGetEnabledTenantFormPartsByFormIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GQLGetEnabledTenantFormPartsByFormIdQuery, GQLGetEnabledTenantFormPartsByFormIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GQLGetEnabledTenantFormPartsByFormIdQuery, GQLGetEnabledTenantFormPartsByFormIdQueryVariables>(GetEnabledTenantFormPartsByFormIdDocument, options);
        }
export type GetEnabledTenantFormPartsByFormIdQueryHookResult = ReturnType<typeof useGetEnabledTenantFormPartsByFormIdQuery>;
export type GetEnabledTenantFormPartsByFormIdLazyQueryHookResult = ReturnType<typeof useGetEnabledTenantFormPartsByFormIdLazyQuery>;
export type GetEnabledTenantFormPartsByFormIdQueryResult = Apollo.QueryResult<GQLGetEnabledTenantFormPartsByFormIdQuery, GQLGetEnabledTenantFormPartsByFormIdQueryVariables>;
export const GetEnabledTenantFormsDocument = gql`
    query GetEnabledTenantForms {
  EnabledTenantForms {
    name
    description
    formID
    isConfigurable
    customForm
  }
}
    `;

/**
 * __useGetEnabledTenantFormsQuery__
 *
 * To run a query within a React component, call `useGetEnabledTenantFormsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEnabledTenantFormsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEnabledTenantFormsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetEnabledTenantFormsQuery(baseOptions?: Apollo.QueryHookOptions<GQLGetEnabledTenantFormsQuery, GQLGetEnabledTenantFormsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GQLGetEnabledTenantFormsQuery, GQLGetEnabledTenantFormsQueryVariables>(GetEnabledTenantFormsDocument, options);
      }
export function useGetEnabledTenantFormsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GQLGetEnabledTenantFormsQuery, GQLGetEnabledTenantFormsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GQLGetEnabledTenantFormsQuery, GQLGetEnabledTenantFormsQueryVariables>(GetEnabledTenantFormsDocument, options);
        }
export type GetEnabledTenantFormsQueryHookResult = ReturnType<typeof useGetEnabledTenantFormsQuery>;
export type GetEnabledTenantFormsLazyQueryHookResult = ReturnType<typeof useGetEnabledTenantFormsLazyQuery>;
export type GetEnabledTenantFormsQueryResult = Apollo.QueryResult<GQLGetEnabledTenantFormsQuery, GQLGetEnabledTenantFormsQueryVariables>;
export const GetFormResultByIdDocument = gql`
    query GetFormResultByID($id: ID!) {
  FormResultByID(formResultID: $id) {
    formResultID
    formID
    formVersion
    createdBy {
      firstName
      infix
      lastName
      tenantID
    }
    name
    formSchema
    uiSchema
    formData
    createdAt
    submittedAt
  }
}
    `;

/**
 * __useGetFormResultByIdQuery__
 *
 * To run a query within a React component, call `useGetFormResultByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFormResultByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFormResultByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetFormResultByIdQuery(baseOptions: Apollo.QueryHookOptions<GQLGetFormResultByIdQuery, GQLGetFormResultByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GQLGetFormResultByIdQuery, GQLGetFormResultByIdQueryVariables>(GetFormResultByIdDocument, options);
      }
export function useGetFormResultByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GQLGetFormResultByIdQuery, GQLGetFormResultByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GQLGetFormResultByIdQuery, GQLGetFormResultByIdQueryVariables>(GetFormResultByIdDocument, options);
        }
export type GetFormResultByIdQueryHookResult = ReturnType<typeof useGetFormResultByIdQuery>;
export type GetFormResultByIdLazyQueryHookResult = ReturnType<typeof useGetFormResultByIdLazyQuery>;
export type GetFormResultByIdQueryResult = Apollo.QueryResult<GQLGetFormResultByIdQuery, GQLGetFormResultByIdQueryVariables>;
export const GetKpiDraftFormsDocument = gql`
    query GetKPIDraftForms {
  KPIDraftForms
}
    `;

/**
 * __useGetKpiDraftFormsQuery__
 *
 * To run a query within a React component, call `useGetKpiDraftFormsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetKpiDraftFormsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetKpiDraftFormsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetKpiDraftFormsQuery(baseOptions?: Apollo.QueryHookOptions<GQLGetKpiDraftFormsQuery, GQLGetKpiDraftFormsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GQLGetKpiDraftFormsQuery, GQLGetKpiDraftFormsQueryVariables>(GetKpiDraftFormsDocument, options);
      }
export function useGetKpiDraftFormsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GQLGetKpiDraftFormsQuery, GQLGetKpiDraftFormsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GQLGetKpiDraftFormsQuery, GQLGetKpiDraftFormsQueryVariables>(GetKpiDraftFormsDocument, options);
        }
export type GetKpiDraftFormsQueryHookResult = ReturnType<typeof useGetKpiDraftFormsQuery>;
export type GetKpiDraftFormsLazyQueryHookResult = ReturnType<typeof useGetKpiDraftFormsLazyQuery>;
export type GetKpiDraftFormsQueryResult = Apollo.QueryResult<GQLGetKpiDraftFormsQuery, GQLGetKpiDraftFormsQueryVariables>;
export const GetKpiIncidentsByCategoryDocument = gql`
    query GetKPIIncidentsByCategory {
  KPIIncidentsByCategory {
    category
    count
  }
}
    `;

/**
 * __useGetKpiIncidentsByCategoryQuery__
 *
 * To run a query within a React component, call `useGetKpiIncidentsByCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetKpiIncidentsByCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetKpiIncidentsByCategoryQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetKpiIncidentsByCategoryQuery(baseOptions?: Apollo.QueryHookOptions<GQLGetKpiIncidentsByCategoryQuery, GQLGetKpiIncidentsByCategoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GQLGetKpiIncidentsByCategoryQuery, GQLGetKpiIncidentsByCategoryQueryVariables>(GetKpiIncidentsByCategoryDocument, options);
      }
export function useGetKpiIncidentsByCategoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GQLGetKpiIncidentsByCategoryQuery, GQLGetKpiIncidentsByCategoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GQLGetKpiIncidentsByCategoryQuery, GQLGetKpiIncidentsByCategoryQueryVariables>(GetKpiIncidentsByCategoryDocument, options);
        }
export type GetKpiIncidentsByCategoryQueryHookResult = ReturnType<typeof useGetKpiIncidentsByCategoryQuery>;
export type GetKpiIncidentsByCategoryLazyQueryHookResult = ReturnType<typeof useGetKpiIncidentsByCategoryLazyQuery>;
export type GetKpiIncidentsByCategoryQueryResult = Apollo.QueryResult<GQLGetKpiIncidentsByCategoryQuery, GQLGetKpiIncidentsByCategoryQueryVariables>;
export const GetKpiSubmittedForms12MonthsDocument = gql`
    query GetKPISubmittedForms12Months {
  KPISubmittedForms12Months
}
    `;

/**
 * __useGetKpiSubmittedForms12MonthsQuery__
 *
 * To run a query within a React component, call `useGetKpiSubmittedForms12MonthsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetKpiSubmittedForms12MonthsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetKpiSubmittedForms12MonthsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetKpiSubmittedForms12MonthsQuery(baseOptions?: Apollo.QueryHookOptions<GQLGetKpiSubmittedForms12MonthsQuery, GQLGetKpiSubmittedForms12MonthsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GQLGetKpiSubmittedForms12MonthsQuery, GQLGetKpiSubmittedForms12MonthsQueryVariables>(GetKpiSubmittedForms12MonthsDocument, options);
      }
export function useGetKpiSubmittedForms12MonthsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GQLGetKpiSubmittedForms12MonthsQuery, GQLGetKpiSubmittedForms12MonthsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GQLGetKpiSubmittedForms12MonthsQuery, GQLGetKpiSubmittedForms12MonthsQueryVariables>(GetKpiSubmittedForms12MonthsDocument, options);
        }
export type GetKpiSubmittedForms12MonthsQueryHookResult = ReturnType<typeof useGetKpiSubmittedForms12MonthsQuery>;
export type GetKpiSubmittedForms12MonthsLazyQueryHookResult = ReturnType<typeof useGetKpiSubmittedForms12MonthsLazyQuery>;
export type GetKpiSubmittedForms12MonthsQueryResult = Apollo.QueryResult<GQLGetKpiSubmittedForms12MonthsQuery, GQLGetKpiSubmittedForms12MonthsQueryVariables>;
export const GetKpiSubmittedWpi12MonthsDocument = gql`
    query GetKPISubmittedWPI12Months {
  KPISubmittedWPI12Months
}
    `;

/**
 * __useGetKpiSubmittedWpi12MonthsQuery__
 *
 * To run a query within a React component, call `useGetKpiSubmittedWpi12MonthsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetKpiSubmittedWpi12MonthsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetKpiSubmittedWpi12MonthsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetKpiSubmittedWpi12MonthsQuery(baseOptions?: Apollo.QueryHookOptions<GQLGetKpiSubmittedWpi12MonthsQuery, GQLGetKpiSubmittedWpi12MonthsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GQLGetKpiSubmittedWpi12MonthsQuery, GQLGetKpiSubmittedWpi12MonthsQueryVariables>(GetKpiSubmittedWpi12MonthsDocument, options);
      }
export function useGetKpiSubmittedWpi12MonthsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GQLGetKpiSubmittedWpi12MonthsQuery, GQLGetKpiSubmittedWpi12MonthsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GQLGetKpiSubmittedWpi12MonthsQuery, GQLGetKpiSubmittedWpi12MonthsQueryVariables>(GetKpiSubmittedWpi12MonthsDocument, options);
        }
export type GetKpiSubmittedWpi12MonthsQueryHookResult = ReturnType<typeof useGetKpiSubmittedWpi12MonthsQuery>;
export type GetKpiSubmittedWpi12MonthsLazyQueryHookResult = ReturnType<typeof useGetKpiSubmittedWpi12MonthsLazyQuery>;
export type GetKpiSubmittedWpi12MonthsQueryResult = Apollo.QueryResult<GQLGetKpiSubmittedWpi12MonthsQuery, GQLGetKpiSubmittedWpi12MonthsQueryVariables>;
export const GetOpenTenantRegistrationsDocument = gql`
    query GetOpenTenantRegistrations {
  OpenTenantRegistrations {
    registrationID
    tenantID
    name
    street
    houseNumber
    postalCode
    city
    emailAddressInvoice
    adminEmailAddress
    adminFirstName
    adminInfix
    adminLastName
    adminPhoneNumber
    purchaseNumber
    status
    isTrial
  }
}
    `;

/**
 * __useGetOpenTenantRegistrationsQuery__
 *
 * To run a query within a React component, call `useGetOpenTenantRegistrationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOpenTenantRegistrationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOpenTenantRegistrationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOpenTenantRegistrationsQuery(baseOptions?: Apollo.QueryHookOptions<GQLGetOpenTenantRegistrationsQuery, GQLGetOpenTenantRegistrationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GQLGetOpenTenantRegistrationsQuery, GQLGetOpenTenantRegistrationsQueryVariables>(GetOpenTenantRegistrationsDocument, options);
      }
export function useGetOpenTenantRegistrationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GQLGetOpenTenantRegistrationsQuery, GQLGetOpenTenantRegistrationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GQLGetOpenTenantRegistrationsQuery, GQLGetOpenTenantRegistrationsQueryVariables>(GetOpenTenantRegistrationsDocument, options);
        }
export type GetOpenTenantRegistrationsQueryHookResult = ReturnType<typeof useGetOpenTenantRegistrationsQuery>;
export type GetOpenTenantRegistrationsLazyQueryHookResult = ReturnType<typeof useGetOpenTenantRegistrationsLazyQuery>;
export type GetOpenTenantRegistrationsQueryResult = Apollo.QueryResult<GQLGetOpenTenantRegistrationsQuery, GQLGetOpenTenantRegistrationsQueryVariables>;
export const GetSubmittedFormsDocument = gql`
    query GetSubmittedForms {
  SubmittedForms {
    formResultID
    formID
    formVersion
    createdBy {
      firstName
      infix
      lastName
      tenantID
    }
    name
    createdAt
    submittedAt
  }
}
    `;

/**
 * __useGetSubmittedFormsQuery__
 *
 * To run a query within a React component, call `useGetSubmittedFormsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubmittedFormsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubmittedFormsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSubmittedFormsQuery(baseOptions?: Apollo.QueryHookOptions<GQLGetSubmittedFormsQuery, GQLGetSubmittedFormsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GQLGetSubmittedFormsQuery, GQLGetSubmittedFormsQueryVariables>(GetSubmittedFormsDocument, options);
      }
export function useGetSubmittedFormsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GQLGetSubmittedFormsQuery, GQLGetSubmittedFormsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GQLGetSubmittedFormsQuery, GQLGetSubmittedFormsQueryVariables>(GetSubmittedFormsDocument, options);
        }
export type GetSubmittedFormsQueryHookResult = ReturnType<typeof useGetSubmittedFormsQuery>;
export type GetSubmittedFormsLazyQueryHookResult = ReturnType<typeof useGetSubmittedFormsLazyQuery>;
export type GetSubmittedFormsQueryResult = Apollo.QueryResult<GQLGetSubmittedFormsQuery, GQLGetSubmittedFormsQueryVariables>;
export const GetTaskByTaskIdDocument = gql`
    query GetTaskByTaskID($id: ID!) {
  TaskByTaskID(taskID: $id) {
    taskID
    summary
    status
    type
    priority
    createdBy
    createdAt
    assignedTo
    assignedToName
    dueDate
    url
  }
}
    `;

/**
 * __useGetTaskByTaskIdQuery__
 *
 * To run a query within a React component, call `useGetTaskByTaskIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaskByTaskIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaskByTaskIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTaskByTaskIdQuery(baseOptions: Apollo.QueryHookOptions<GQLGetTaskByTaskIdQuery, GQLGetTaskByTaskIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GQLGetTaskByTaskIdQuery, GQLGetTaskByTaskIdQueryVariables>(GetTaskByTaskIdDocument, options);
      }
export function useGetTaskByTaskIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GQLGetTaskByTaskIdQuery, GQLGetTaskByTaskIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GQLGetTaskByTaskIdQuery, GQLGetTaskByTaskIdQueryVariables>(GetTaskByTaskIdDocument, options);
        }
export type GetTaskByTaskIdQueryHookResult = ReturnType<typeof useGetTaskByTaskIdQuery>;
export type GetTaskByTaskIdLazyQueryHookResult = ReturnType<typeof useGetTaskByTaskIdLazyQuery>;
export type GetTaskByTaskIdQueryResult = Apollo.QueryResult<GQLGetTaskByTaskIdQuery, GQLGetTaskByTaskIdQueryVariables>;
export const GetTaskCommentsByTaskIdDocument = gql`
    query GetTaskCommentsByTaskID($id: ID!) {
  TaskCommentsByTaskID(taskID: $id) {
    commentID
    taskID
    description
    createdBy
    createdAt
  }
}
    `;

/**
 * __useGetTaskCommentsByTaskIdQuery__
 *
 * To run a query within a React component, call `useGetTaskCommentsByTaskIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaskCommentsByTaskIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaskCommentsByTaskIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTaskCommentsByTaskIdQuery(baseOptions: Apollo.QueryHookOptions<GQLGetTaskCommentsByTaskIdQuery, GQLGetTaskCommentsByTaskIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GQLGetTaskCommentsByTaskIdQuery, GQLGetTaskCommentsByTaskIdQueryVariables>(GetTaskCommentsByTaskIdDocument, options);
      }
export function useGetTaskCommentsByTaskIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GQLGetTaskCommentsByTaskIdQuery, GQLGetTaskCommentsByTaskIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GQLGetTaskCommentsByTaskIdQuery, GQLGetTaskCommentsByTaskIdQueryVariables>(GetTaskCommentsByTaskIdDocument, options);
        }
export type GetTaskCommentsByTaskIdQueryHookResult = ReturnType<typeof useGetTaskCommentsByTaskIdQuery>;
export type GetTaskCommentsByTaskIdLazyQueryHookResult = ReturnType<typeof useGetTaskCommentsByTaskIdLazyQuery>;
export type GetTaskCommentsByTaskIdQueryResult = Apollo.QueryResult<GQLGetTaskCommentsByTaskIdQuery, GQLGetTaskCommentsByTaskIdQueryVariables>;
export const GetTaskOverviewDocument = gql`
    query GetTaskOverview($filter: TaskWithfilterOptionsParams!) {
  TaskOverview(filter: $filter) {
    FormResultID
    taskID
    summary
    status
    type
    priority
    createdBy
    createdAt
    assignedTo
    assignedToName
    dueDate
    url
  }
}
    `;

/**
 * __useGetTaskOverviewQuery__
 *
 * To run a query within a React component, call `useGetTaskOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaskOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaskOverviewQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetTaskOverviewQuery(baseOptions: Apollo.QueryHookOptions<GQLGetTaskOverviewQuery, GQLGetTaskOverviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GQLGetTaskOverviewQuery, GQLGetTaskOverviewQueryVariables>(GetTaskOverviewDocument, options);
      }
export function useGetTaskOverviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GQLGetTaskOverviewQuery, GQLGetTaskOverviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GQLGetTaskOverviewQuery, GQLGetTaskOverviewQueryVariables>(GetTaskOverviewDocument, options);
        }
export type GetTaskOverviewQueryHookResult = ReturnType<typeof useGetTaskOverviewQuery>;
export type GetTaskOverviewLazyQueryHookResult = ReturnType<typeof useGetTaskOverviewLazyQuery>;
export type GetTaskOverviewQueryResult = Apollo.QueryResult<GQLGetTaskOverviewQuery, GQLGetTaskOverviewQueryVariables>;
export const TaskOverviewByFormResultIdDocument = gql`
    query TaskOverviewByFormResultID($formResultID: ID!) {
  TaskOverviewByFormResultID(formResultID: $formResultID) {
    taskID
    summary
    status
    type
    priority
    createdBy
    createdAt
    assignedTo
    assignedToName
    dueDate
    FormResultID
    url
  }
}
    `;

/**
 * __useTaskOverviewByFormResultIdQuery__
 *
 * To run a query within a React component, call `useTaskOverviewByFormResultIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskOverviewByFormResultIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskOverviewByFormResultIdQuery({
 *   variables: {
 *      formResultID: // value for 'formResultID'
 *   },
 * });
 */
export function useTaskOverviewByFormResultIdQuery(baseOptions: Apollo.QueryHookOptions<GQLTaskOverviewByFormResultIdQuery, GQLTaskOverviewByFormResultIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GQLTaskOverviewByFormResultIdQuery, GQLTaskOverviewByFormResultIdQueryVariables>(TaskOverviewByFormResultIdDocument, options);
      }
export function useTaskOverviewByFormResultIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GQLTaskOverviewByFormResultIdQuery, GQLTaskOverviewByFormResultIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GQLTaskOverviewByFormResultIdQuery, GQLTaskOverviewByFormResultIdQueryVariables>(TaskOverviewByFormResultIdDocument, options);
        }
export type TaskOverviewByFormResultIdQueryHookResult = ReturnType<typeof useTaskOverviewByFormResultIdQuery>;
export type TaskOverviewByFormResultIdLazyQueryHookResult = ReturnType<typeof useTaskOverviewByFormResultIdLazyQuery>;
export type TaskOverviewByFormResultIdQueryResult = Apollo.QueryResult<GQLTaskOverviewByFormResultIdQuery, GQLTaskOverviewByFormResultIdQueryVariables>;
export const GetTenantOrganizationDetailsDocument = gql`
    query GetTenantOrganizationDetails {
  TenantOrganizationDetails {
    organizationID
    tenantID
    name
    logo
    street
    houseNumber
    postalCode
    city
    emailAddressInvoice
    purchaseNumber
    enabled
    createdAt
    trialStartDate
    status
  }
}
    `;

/**
 * __useGetTenantOrganizationDetailsQuery__
 *
 * To run a query within a React component, call `useGetTenantOrganizationDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTenantOrganizationDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTenantOrganizationDetailsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTenantOrganizationDetailsQuery(baseOptions?: Apollo.QueryHookOptions<GQLGetTenantOrganizationDetailsQuery, GQLGetTenantOrganizationDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GQLGetTenantOrganizationDetailsQuery, GQLGetTenantOrganizationDetailsQueryVariables>(GetTenantOrganizationDetailsDocument, options);
      }
export function useGetTenantOrganizationDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GQLGetTenantOrganizationDetailsQuery, GQLGetTenantOrganizationDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GQLGetTenantOrganizationDetailsQuery, GQLGetTenantOrganizationDetailsQueryVariables>(GetTenantOrganizationDetailsDocument, options);
        }
export type GetTenantOrganizationDetailsQueryHookResult = ReturnType<typeof useGetTenantOrganizationDetailsQuery>;
export type GetTenantOrganizationDetailsLazyQueryHookResult = ReturnType<typeof useGetTenantOrganizationDetailsLazyQuery>;
export type GetTenantOrganizationDetailsQueryResult = Apollo.QueryResult<GQLGetTenantOrganizationDetailsQuery, GQLGetTenantOrganizationDetailsQueryVariables>;
export const GetTranslationsDocument = gql`
    query GetTranslations {
  Translations {
    id
    namespace
    key
    en
    nl
  }
}
    `;

/**
 * __useGetTranslationsQuery__
 *
 * To run a query within a React component, call `useGetTranslationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTranslationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTranslationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTranslationsQuery(baseOptions?: Apollo.QueryHookOptions<GQLGetTranslationsQuery, GQLGetTranslationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GQLGetTranslationsQuery, GQLGetTranslationsQueryVariables>(GetTranslationsDocument, options);
      }
export function useGetTranslationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GQLGetTranslationsQuery, GQLGetTranslationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GQLGetTranslationsQuery, GQLGetTranslationsQueryVariables>(GetTranslationsDocument, options);
        }
export type GetTranslationsQueryHookResult = ReturnType<typeof useGetTranslationsQuery>;
export type GetTranslationsLazyQueryHookResult = ReturnType<typeof useGetTranslationsLazyQuery>;
export type GetTranslationsQueryResult = Apollo.QueryResult<GQLGetTranslationsQuery, GQLGetTranslationsQueryVariables>;
export const GetUserAccountsDocument = gql`
    query GetUserAccounts($active: Boolean) {
  UserAccounts(active: $active) {
    emailAddress
    userID
    roles {
      roleID
      roleName
      description
    }
    active
    preferences
    permissions
    firstName
    infix
    lastName
    tenantID
    fullName
  }
}
    `;

/**
 * __useGetUserAccountsQuery__
 *
 * To run a query within a React component, call `useGetUserAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserAccountsQuery({
 *   variables: {
 *      active: // value for 'active'
 *   },
 * });
 */
export function useGetUserAccountsQuery(baseOptions?: Apollo.QueryHookOptions<GQLGetUserAccountsQuery, GQLGetUserAccountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GQLGetUserAccountsQuery, GQLGetUserAccountsQueryVariables>(GetUserAccountsDocument, options);
      }
export function useGetUserAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GQLGetUserAccountsQuery, GQLGetUserAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GQLGetUserAccountsQuery, GQLGetUserAccountsQueryVariables>(GetUserAccountsDocument, options);
        }
export type GetUserAccountsQueryHookResult = ReturnType<typeof useGetUserAccountsQuery>;
export type GetUserAccountsLazyQueryHookResult = ReturnType<typeof useGetUserAccountsLazyQuery>;
export type GetUserAccountsQueryResult = Apollo.QueryResult<GQLGetUserAccountsQuery, GQLGetUserAccountsQueryVariables>;
export const GetUserListDocument = gql`
    query GetUserList($active: Boolean) {
  UserAccounts(active: $active) {
    id: userID
    name: fullName
  }
}
    `;

/**
 * __useGetUserListQuery__
 *
 * To run a query within a React component, call `useGetUserListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserListQuery({
 *   variables: {
 *      active: // value for 'active'
 *   },
 * });
 */
export function useGetUserListQuery(baseOptions?: Apollo.QueryHookOptions<GQLGetUserListQuery, GQLGetUserListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GQLGetUserListQuery, GQLGetUserListQueryVariables>(GetUserListDocument, options);
      }
export function useGetUserListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GQLGetUserListQuery, GQLGetUserListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GQLGetUserListQuery, GQLGetUserListQueryVariables>(GetUserListDocument, options);
        }
export type GetUserListQueryHookResult = ReturnType<typeof useGetUserListQuery>;
export type GetUserListLazyQueryHookResult = ReturnType<typeof useGetUserListLazyQuery>;
export type GetUserListQueryResult = Apollo.QueryResult<GQLGetUserListQuery, GQLGetUserListQueryVariables>;
export const GetMyDraftFormsDocument = gql`
    query GetMyDraftForms {
  MyDraftForms {
    formResultID
    formID
    formVersion
    name
    description
    formSchema
    uiSchema
    formData
    createdAt
  }
}
    `;

/**
 * __useGetMyDraftFormsQuery__
 *
 * To run a query within a React component, call `useGetMyDraftFormsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyDraftFormsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyDraftFormsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyDraftFormsQuery(baseOptions?: Apollo.QueryHookOptions<GQLGetMyDraftFormsQuery, GQLGetMyDraftFormsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GQLGetMyDraftFormsQuery, GQLGetMyDraftFormsQueryVariables>(GetMyDraftFormsDocument, options);
      }
export function useGetMyDraftFormsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GQLGetMyDraftFormsQuery, GQLGetMyDraftFormsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GQLGetMyDraftFormsQuery, GQLGetMyDraftFormsQueryVariables>(GetMyDraftFormsDocument, options);
        }
export type GetMyDraftFormsQueryHookResult = ReturnType<typeof useGetMyDraftFormsQuery>;
export type GetMyDraftFormsLazyQueryHookResult = ReturnType<typeof useGetMyDraftFormsLazyQuery>;
export type GetMyDraftFormsQueryResult = Apollo.QueryResult<GQLGetMyDraftFormsQuery, GQLGetMyDraftFormsQueryVariables>;
export const GetUserRolesDocument = gql`
    query GetUserRoles {
  Roles {
    roleID
    roleName
  }
}
    `;

/**
 * __useGetUserRolesQuery__
 *
 * To run a query within a React component, call `useGetUserRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserRolesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserRolesQuery(baseOptions?: Apollo.QueryHookOptions<GQLGetUserRolesQuery, GQLGetUserRolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GQLGetUserRolesQuery, GQLGetUserRolesQueryVariables>(GetUserRolesDocument, options);
      }
export function useGetUserRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GQLGetUserRolesQuery, GQLGetUserRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GQLGetUserRolesQuery, GQLGetUserRolesQueryVariables>(GetUserRolesDocument, options);
        }
export type GetUserRolesQueryHookResult = ReturnType<typeof useGetUserRolesQuery>;
export type GetUserRolesLazyQueryHookResult = ReturnType<typeof useGetUserRolesLazyQuery>;
export type GetUserRolesQueryResult = Apollo.QueryResult<GQLGetUserRolesQuery, GQLGetUserRolesQueryVariables>;